// ── Scroll reveal + FPS bar animations
document.querySelectorAll('.bar-pc[data-w]').forEach(b => b.style.width = '0%');

function revealEl(el) {
 if (el.dataset.revealed) return;
 el.dataset.revealed = '1';
 requestAnimationFrame(() => el.classList.add('visible'));
}

function animateBar(b) {
 if (b.dataset.done) return;
 b.dataset.done = '1';
 requestAnimationFrame(() => { b.style.width = (b.dataset.w || 0) + '%'; });
}

if ('IntersectionObserver' in window) {
 const fadeObs = new IntersectionObserver((entries) => {
 entries.forEach(e => { if (e.isIntersecting) { revealEl(e.target); fadeObs.unobserve(e.target); } });
 }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });

 const barObs = new IntersectionObserver((entries) => {
 entries.forEach(e => { if (e.isIntersecting) { animateBar(e.target); barObs.unobserve(e.target); } });
 }, { threshold: 0, rootMargin: '60px 0px 60px 0px' });

 document.querySelectorAll('.fade-up').forEach(el => fadeObs.observe(el));
 document.querySelectorAll('.bar-pc[data-w]').forEach(b => barObs.observe(b));

} else {
 const fadeEls = document.querySelectorAll('.fade-up');
 const bars = document.querySelectorAll('.bar-pc[data-w]');

 function checkAll() {
 const vh = window.innerHeight;
 fadeEls.forEach(el => {
 if (!el.dataset.revealed && el.getBoundingClientRect().top < vh * 0.92) revealEl(el);
 });
 bars.forEach(b => {
 if (!b.dataset.done && b.getBoundingClientRect().top < vh + 60) animateBar(b);
 });
 }

 window.addEventListener('scroll', checkAll, { passive: true });
 window.addEventListener('resize', checkAll, { passive: true });
 requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(checkAll, 50)));
}

// ── Filter
function doFilter(tier, btn) {
 document.querySelectorAll('.filter-pill').forEach(p => p.classList.remove('active'));
 btn.classList.add('active');
 document.querySelectorAll('#pgrid .product-card').forEach(c => {
 c.style.display = (tier === 'all' || c.dataset.tier === tier) ? '' : 'none';
 });
}

// ── System data
// Prices, specs, and FPS figures updated April 2026.
// Native FPS benchmarks sourced from GamersNexus, HardwareUnboxed, Digital Foundry.
// Arc A750: ~75fps Cyberpunk 1080p, ~90fps Fortnite high, driver-matured 2025.
// Arc B580: ~95-100fps Cyberpunk 1080p, ~210-260fps Fortnite, 12GB VRAM helps at 1440p.
// B580 takes ~10-18% hit when paired with Ryzen 5 5600 vs flagship CPUs.
// RTX 5060 8GB: GN review — 66fps Starfield, 25% over 4060 avg; DLSS 4 MFG ~2.2x.
// RTX 5060 Ti 16GB: GN review — 104fps avg 1440p across 20 games; 22% over 5060.
// RTX 5070 12GB: GN review — 126fps 1080p avg, 89fps Cyberpunk 1440p, 41fps 4K; ~90fps avg 1440p.
// RTX 5070 Ti 16GB: GN review — 131fps 1080p, 108fps Cyberpunk 1440p, 50fps 4K; 24% over 5070.
// RTX 5090 32GB: GN review — 95fps Cyberpunk 4K, 214fps 1080p avg, 50% over 4090.
// MFG multipliers: 5060/5060Ti/5070: ~2.2x | 5070Ti: ~2.3x | 5090: ~2.4x at 1080p/1440p.
const SYSTEMS = {
 core: {
 name: 'Core', priceNum: 999.00, badge: 'Entry · 1080p',
 tagline: 'Built for 1080p.',
 target: '1080p / 60–144Hz monitor',
 specs: {},
 },
 corex: {
 name: 'Core X', priceNum: 1199.00, badge: 'Entry · 1080p',
 tagline: 'Frame Generation comes standard.',
 target: '1080p / 144–165Hz monitor',
 specs: {},
 },
 pro: {
 name: 'Pro', priceNum: 1499.00, badge: 'Mid-Range · 1080p / 1440p',
 tagline: 'DLSS 4 enters the lineup.',
 target: '1080p–1440p / 144–165Hz monitor',
 specs: {},
 },
 prox: {
 name: 'Pro X', priceNum: 1899.00, badge: 'Mid-Range · 1080p / 1440p',
 tagline: '16GB of VRAM. 32GB of memory.',
 target: '1080p–1440p / 165–240Hz monitor',
 specs: {},
 },
 ultra: {
 name: 'Ultra', priceNum: 2249.00, badge: 'High-End · 1440p',
 tagline: 'Current-gen AM5 platform.',
 target: '1440p / 165–240Hz monitor',
 specs: {},
 },
 ultrax: {
 name: 'Ultra X', priceNum: 2999.00, badge: 'High-End · 1440p / 4K',
 tagline: '7800X3D paired with the RTX 5070 Ti.',
 target: '1440p–4K / 165–240Hz monitor',
 specs: {},
 },
 max: {
 name: 'Max', priceNum: 7699.00, badge: 'Enthusiast · 1440p / 4K',
 tagline: 'RTX 5090. The 4K flagship.',
 target: '4K / 240Hz+ monitor',
 specs: {},
 }
};

// ── Live price sync from Shopify
(function patchSystemPrices() {
 const prices = window.__GRASSAN_PRICES__;
 if (!prices) return;
 Object.keys(prices).forEach(function(key) {
 if (!SYSTEMS[key]) return;
 const p = prices[key];
 // Only overwrite the hardcoded fallback if Shopify returned a real price.
 // p.price is in dollars; 0 means the product is missing/unpublished.
 if (p && typeof p.price === 'number' && p.price > 0) {
 SYSTEMS[key].priceNum = p.price;
 SYSTEMS[key].price = p.formatted;
 }
 });
})();

// Order for "best" comparisons
const ORDER = ['core','corex','pro','prox','ultra','ultrax','max'];

// ── Parts list (from BOM, April 2026)
// ── Parts list data (synced from Shopify CSV — do not edit manually)
const PARTS = {
 core: { parts: [] },
 corex: { parts: [] },
 pro: { parts: [] },
 prox: { parts: [] },
 ultra: { parts: [] },
 ultrax: { parts: [] },
 max: { parts: [] },
};

// Patch PARTS from Shopify product tags injected by index.liquid
// Falls back to hardcoded PARTS if tags aren't available
(function patchFromShopify() {
 var live = window.__GRASSAN_PARTS__;
 if (!live) return;
 Object.keys(live).forEach(function(key) {
 var data = live[key];
 if (!data) return;

 // Patch PARTS (parts drawer)
 if (PARTS[key] && Array.isArray(data.parts) && data.parts.length > 0) {
 PARTS[key].parts = data.parts;
 }

 // Patch SYSTEMS.specs from spec: tags — single source of truth
 if (SYSTEMS[key] && data.specs && Object.keys(data.specs).length > 0) {
 var s = data.specs;
 var sys = SYSTEMS[key];
 if (!sys.specs) sys.specs = {};
 // Trim spec values to handle CSV whitespace
 if (s.Processor) sys.specs.Processor = String(s.Processor).trim();
 if (s.Graphics) sys.specs.Graphics = String(s.Graphics).trim();
 if (s.Memory) sys.specs.Memory = String(s.Memory).trim();
 if (s.Storage) sys.specs.Storage = String(s.Storage).trim();
 if (s.Cooling) sys.specs.Cooling = String(s.Cooling).trim();
 if (s.Platform) sys.specs.Platform = String(s.Platform).trim();
 if (s['Frame Gen']) {
 sys.specs.FrameGen = String(s['Frame Gen']).trim();
 } else if (s.Graphics) {
 // Live Shopify data may not carry a spec:Frame Gen tag. Derive it
 // from the GPU model so the comparison tool can still reason about
 // upscaling capability differences. The GPU determines what
 // upscaling/FG paths the system actually has access to.
 var gpuLower = String(s.Graphics).toLowerCase();
 if (/rtx\s*5[0-9]{3}/.test(gpuLower)) {
 sys.specs.FrameGen = 'DLSS4 SR + MFG 2×';
 } else if (/rtx\s*4[0-9]{3}/.test(gpuLower)) {
 sys.specs.FrameGen = 'DLSS3 SR + FG';
 } else if (/rtx\s*[23][0-9]{3}/.test(gpuLower)) {
 sys.specs.FrameGen = 'DLSS SR';
 } else if (/arc\s*b\d/.test(gpuLower)) {
 sys.specs.FrameGen = 'XeSS 2 SR + FG';
 } else if (/arc\s*a\d/.test(gpuLower)) {
 sys.specs.FrameGen = 'XeSS SR';
 } else if (/rx\s*[7-9]\d{3}/.test(gpuLower)) {
 sys.specs.FrameGen = 'FSR 3 SR + FG';
 } else if (/rx\s*[5-6]\d{3}/.test(gpuLower)) {
 sys.specs.FrameGen = 'FSR SR';
 }
 }

 // VRAM: derived from the most specific source available.
 // Check the part: Graphics tag first (e.g. "GeForce RTX 5060 Ti 16GB"
 // includes the variant size), then fall back to the spec value, then
 // a GPU model lookup table. Case-insensitive everywhere.
 if (sys.specs.Graphics) {
 var gpu = sys.specs.Graphics;
 // First, look in parts for a more specific Graphics string (with "16GB" etc.)
 var gpuPart = '';
 if (Array.isArray(data.parts)) {
 for (var pi = 0; pi < data.parts.length; pi++) {
 if (data.parts[pi] && data.parts[pi].cat === 'Graphics') {
 gpuPart = String(data.parts[pi].name || '');
 break;
 }
 }
 }
 var vramSource = gpuPart || gpu;
 var vramMatch = vramSource.match(/(\d+)\s*gb/i);
 if (vramMatch) {
 sys.specs.VRAM = vramMatch[1] + 'GB';
 } else {
 // GPU model → VRAM lookup. Keys lowercased for case-insensitive match.
 var GPU_VRAM = {
 // Intel Arc
 'arc a380': '6GB',
 'arc a580': '8GB',
 'arc a750': '8GB',
 'arc a770': '16GB',
 'arc b570': '10GB',
 'arc b580': '12GB',
 // AMD RX 6000
 'rx 6500 xt': '4GB',
 'rx 6600': '8GB',
 'rx 6600 xt': '8GB',
 'rx 6650 xt': '8GB',
 'rx 6700 xt': '12GB',
 'rx 6750 xt': '12GB',
 'rx 6800': '16GB',
 'rx 6800 xt': '16GB',
 'rx 6900 xt': '16GB',
 'rx 6950 xt': '16GB',
 // AMD RX 7000
 'rx 7700 xt': '12GB',
 'rx 7800 xt': '16GB',
 'rx 7900 gre': '16GB',
 'rx 7900 xt': '20GB',
 'rx 7900 xtx': '24GB',
 // AMD RX 9000 (RDNA 4)
 'rx 9060 xt': '16GB',
 'rx 9070': '16GB',
 'rx 9070 xt': '16GB',
 // Nvidia RTX 30
 'rtx 3050': '8GB',
 'rtx 3060': '12GB',
 'rtx 3060 ti': '8GB',
 'rtx 3070': '8GB',
 'rtx 3070 ti': '8GB',
 'rtx 3080': '10GB',
 'rtx 3080 ti': '12GB',
 'rtx 3090': '24GB',
 'rtx 3090 ti': '24GB',
 // Nvidia RTX 40
 'rtx 4060': '8GB',
 'rtx 4060 ti': '8GB',
 'rtx 4070': '12GB',
 'rtx 4070 super': '12GB',
 'rtx 4070 ti': '12GB',
 'rtx 4070 ti super':'16GB',
 'rtx 4080': '16GB',
 'rtx 4080 super': '16GB',
 'rtx 4090': '24GB',
 // Nvidia RTX 50
 'rtx 5050': '8GB',
 'rtx 5060': '8GB',
 'rtx 5060 ti': '8GB',     // 5060 Ti also has a 16GB variant; use part name "16GB" to trigger that
 'rtx 5070': '12GB',
 'rtx 5070 ti': '16GB',
 'rtx 5080': '16GB',
 'rtx 5090': '32GB',
 };
 // Normalize: lowercase + collapse multi-spaces to single space
 var lookupKey = gpu.toLowerCase().replace(/\s+/g, ' ').trim();
 // Strip vendor prefixes ("Intel ", "AMD ", "Radeon ", "GeForce ", "Nvidia ")
 // so "Intel ARC A750" matches "arc a750", "Intel Arc B580" matches "arc b580", etc.
 lookupKey = lookupKey.replace(/^(intel|amd|nvidia|geforce|radeon)\s+/, '');
 if (GPU_VRAM[lookupKey]) {
 sys.specs.VRAM = GPU_VRAM[lookupKey];
 } else {
 // Try matching the longest GPU_VRAM key that appears as a substring
 // of the cleaned lookup key (handles "rtx 5060 ti 16gb" → "rtx 5060 ti")
 var bestKey = '';
 Object.keys(GPU_VRAM).forEach(function(k) {
 if (lookupKey.indexOf(k) !== -1 && k.length > bestKey.length) bestKey = k;
 });
 if (bestKey) sys.specs.VRAM = GPU_VRAM[bestKey];
 else console.warn('[Grassan] Unknown GPU for VRAM lookup:', gpu);
 }
 }
 }
 }
 });
})();

// ── Attach button listeners imperatively on DOM ready
// This ensures onclick handlers work even if the user taps before defer script finishes
document.addEventListener('DOMContentLoaded', function() {
 // Compare buttons
 document.querySelectorAll('.btn-compare').forEach(function(btn) {
 btn.removeAttribute('onclick');
 function handler(e) { e.stopPropagation(); toggleCompare(btn); }
 btn.addEventListener('click', handler);
 btn.addEventListener('touchend', function(e) { e.preventDefault(); handler(e); });
 });

 // Get Started buttons
 document.querySelectorAll('.btn-get-started').forEach(function(btn) {
 btn.removeAttribute('onclick');
 function handler(e) { e.stopPropagation(); getStarted(btn); }
 btn.addEventListener('click', handler);
 btn.addEventListener('touchend', function(e) { e.preventDefault(); handler(e); });
 });

 // FPS tooltip buttons
 document.querySelectorAll('.fps-tooltip-btn').forEach(function(btn) {
 btn.removeAttribute('onclick');
 btn.addEventListener('click', function(e) { toggleFpsTooltip(e); });
 btn.addEventListener('touchend', function(e) { e.preventDefault(); toggleFpsTooltip(e); });
 });

 // Filter pills
 document.querySelectorAll('.filter-pill').forEach(function(btn) {
 var tier = btn.getAttribute('onclick') && btn.getAttribute('onclick').match(/doFilter\('([^']+)'/);
 if (!tier) return;
 var t = tier[1];
 btn.removeAttribute('onclick');
 function handler(e) { e.stopPropagation(); doFilter(t, btn); }
 btn.addEventListener('click', handler);
 btn.addEventListener('touchend', function(e) { e.preventDefault(); handler(e); });
 });
});

// ── Parts drawer
function openParts(key) {
 const p = PARTS[key];
 const s = SYSTEMS[key];
 if (!p || !s) { grassanError('PARTS-001', 'key: ' + key); return; }
 if (!p.parts || p.parts.length === 0) { grassanError('PARTS-002', 'key: ' + key); return; }

 const overlay = document.getElementById('partsOverlay');
 const title = document.getElementById('partsDrawerTitle');
 const sub = document.getElementById('partsDrawerSubtitle');
 const body = document.getElementById('partsDrawerBody');
 if (!overlay || !title || !sub || !body) {
 grassanError('PARTS-001', 'drawer element missing');
 return;
 }

 title.textContent = 'Grassan ' + s.name;
 sub.textContent = s.tagline;

 let html = '';
 p.parts.forEach(function(item) {
 html += '<div class="parts-item">'
 + '<span class="parts-item-cat">' + item.cat + '</span>'
 + '<span class="parts-item-name">' + item.name + '</span>'
 + '</div>';
 });

 body.innerHTML = html;
 overlay.classList.add('open');
 document.body.style.overflow = 'hidden';
}

function closeParts() {
 document.getElementById('partsOverlay').classList.remove('open');
 document.body.style.overflow = '';
}

function partsOverlayClick(e) {
 if (e.target === document.getElementById('partsOverlay')) closeParts();
}

function getSystemKey(cardEl) {
 // Prefer explicit data-build-key (index.liquid cards)
 if (cardEl.dataset.buildKey) return cardEl.dataset.buildKey;
 // Fall back to data-handle (product-lineup.liquid cards)
 if (cardEl.dataset.handle) {
 const handleMap = {
 'grassan-core':'core','grassan-core-x':'corex','grassan-pro':'pro',
 'grassan-pro-x':'prox','grassan-ultra':'ultra','grassan-ultra-x':'ultrax','grassan-max':'max'
 };
 if (handleMap[cardEl.dataset.handle]) return handleMap[cardEl.dataset.handle];
 }
 // Last resort: text match
 const name = cardEl.querySelector('.product-name')?.textContent?.trim().toLowerCase().replace(/\s+/g,'');
 const map = { core:'core', corex:'corex', pro:'pro', prox:'prox', ultra:'ultra', ultrax:'ultrax', max:'max' };
 return map[name] || null;
}

// ── Comparison state
var selected = [];

function updateBar() {
 const bar = document.getElementById('compareBar');
 const btn = document.getElementById('compareNowBtn');
 selected.length > 0 ? bar.classList.add('visible') : bar.classList.remove('visible');
 for (let i = 0; i < 3; i++) {
 const slot = document.getElementById(`slot${i}`);
 if (selected[i]) {
 const sys = SYSTEMS[selected[i]];
 slot.classList.add('filled');
 slot.innerHTML = `<span class="compare-slot-name">${sys.name}</span><button class="compare-slot-remove" onclick="removeFromCompare('${selected[i]}')">×</button>`;
 } else {
 slot.classList.remove('filled');
 slot.innerHTML = `<span class="compare-slot-name" style="color:rgba(255,255,255,0.25);">Choose a system</span>`;
 }
 }
 btn.disabled = selected.length < 2;
 document.querySelectorAll('.btn-compare').forEach(b => {
 const card = b.closest('.product-card');
 if (!card) return;
 const key = getSystemKey(card);
 const isSel = selected.includes(key);
 const isFull = selected.length >= 3 && !isSel;
 b.classList.toggle('selected', isSel);
 b.classList.toggle('disabled', isFull);
 b.textContent = isSel ? '✓ Added' : '+ Add to Comparison';
 });
}

function toggleCompare(btn) {
 const card = btn.closest('.product-card');
 const key = getSystemKey(card);
 if (!key) { grassanError('CMP-001', 'card el: ' + (card ? card.outerHTML.slice(0,80) : 'null')); return; }
 if (selected.includes(key)) {
 selected = selected.filter(k => k !== key);
 } else if (selected.length < 3) {
 selected.push(key);
 } else {
 grassanError('CMP-004');
 return;
 }
 updateBar();
}

function removeFromCompare(key) {
 selected = selected.filter(k => k !== key);
 updateBar();
}

function clearAll() {
 selected = [];
 updateBar();
}

// ── Generate human analysis points
function generateAnalysis(systems) {
 const points = [];
 if (systems.length < 2) return points;

 // Sort low → high by price
 const sorted = [...systems].sort((a,b) => a.sys.priceNum - b.sys.priceNum);
 const low = sorted[0], high = sorted[sorted.length - 1];
 const lowSys = low.sys, highSys = high.sys;

 // Helper: extract memory size in GB. Handles kit notation like "2x16GB" → 32.
 function memGB(s) {
 var str = String(s||'');
 // Try kit notation first: 2x16GB, 4x8GB, 2 x 16GB, etc.
 var kit = str.match(/(\d+)\s*[x×]\s*(\d+)\s*gb/i);
 if (kit) return parseInt(kit[1],10) * parseInt(kit[2],10);
 // Otherwise just first NN GB occurrence
 var m = str.match(/(\d+)\s*gb/i);
 return m ? parseInt(m[1],10) : null;
 }
 // Helper: extract memory type (DDR4, DDR5)
 function memType(s) { var m = String(s||'').match(/ddr\d/i); return m ? m[0].toUpperCase() : null; }
 // Helper: extract storage size in GB from "1TB SSD", "2TB SSD", "512GB SSD"
 function storageGB(s) {
 var t = String(s||'').toLowerCase();
 var tb = t.match(/(\d+(?:\.\d+)?)\s*tb/);
 if (tb) return parseFloat(tb[1]) * 1000;
 var gb = t.match(/(\d+)\s*gb/);
 if (gb) return parseInt(gb[1],10);
 return null;
 }
 // Helper: compress a verbose live GPU string ("GeForce RTX 5070 Ti 16GB",
 // "Intel ARC A750") into a clean short name ("RTX 5070 Ti", "Arc A750")
 // for use in analysis prose. Keeps capacity if it disambiguates a 16GB
 // vs 8GB variant (5060 Ti specifically).
 function gpuShort(s) {
 var str = String(s||'').trim();
 if (!str) return str;
 // Strip vendor prefixes
 str = str.replace(/^(NVIDIA\s+|AMD\s+|Intel\s+)/i, '');
 str = str.replace(/^(GeForce\s+|Radeon\s+)/i, '');
 // Normalize "ARC" casing
 str = str.replace(/\bARC\b/, 'Arc');
 // Strip trailing capacity ("RTX 5090 32GB" → "RTX 5090") UNLESS the
 // model has both 8GB and 16GB variants where the suffix matters.
 var keepGB = /5060\s*ti/i.test(str); // 5060 Ti has 8GB and 16GB SKUs
 if (!keepGB) {
 str = str.replace(/\s+\d+\s*GB\s*$/i, '');
 }
 return str.trim();
 }
 // Helper: extract VRAM in GB
 function vramGB(s) { var m = String(s||'').match(/(\d+)\s*gb/i); return m ? parseInt(m[1],10) : null; }

 // Helper: parse a Ryzen CPU model string into structured tier info.
 // Returns { gen, family, x3d, raw } or null if unrecognized.
 // gen = Zen architecture (3, 4, 5) inferred from model number
 // family = 5 / 7 / 9 (Ryzen tier)
 // x3d = true if model has X3D suffix
 function parseRyzen(s) {
 var str = String(s||'');
 var m = str.match(/Ryzen\s+(\d)\s+(\d)(\d{3})([A-Z0-9]*)/i);
 if (!m) return null;
 var family = parseInt(m[1],10);
 var firstDigit = parseInt(m[2],10); // 5 = Zen 3, 7 = Zen 4, 9 = Zen 5
 var suffix = (m[4]||'').toUpperCase();
 var gen = ({5:3, 7:4, 9:5})[firstDigit] || 0;
 // Trim leading vendor prefixes for cleaner prose ("AMD Ryzen 5 5500" → "Ryzen 5 5500")
 var raw = str.trim().replace(/^(AMD|Intel)\s+/i, '');
 return { gen: gen, family: family, x3d: /X3D/.test(suffix), raw: raw };
 }

 // Helper: classify the upscaling tier (0 = none, 4 = DLSS 4 MFG)
 function upscaleTier(s) {
 var str = String(s||'').toLowerCase();
 if (/dlss\s*4/.test(str) && /mfg/.test(str)) return 4;
 if (/dlss\s*3/.test(str) || /dlss\s*4/.test(str)) return 3;
 if (/xess\s*2/.test(str) && /(fg|frame)/.test(str)) return 2.5;
 if (/xess/.test(str)) return 2;
 if (/fsr/.test(str)) return 1;
 return 0;
 }

 // Helper: rough GPU performance tier for analysis prose. Uses the same
 // ladder as the comparison table's RANKINGS.Graphics, kept here as a
 // separate copy because RANKINGS lives inside buildCompareContent's
 // closure. Lower index = lower tier.
 var GPU_TIER = [
 'RX 6600','Arc A750','Arc B580','RTX 5060',
 'RTX 5060 Ti','RTX 5070','RTX 5070 Ti','RTX 5080','RTX 5090',
 ];
 function gpuTier(s) {
 var str = String(s||'').trim();
 if (!str) return -1;
 // Allow "GeForce RTX 5060 Ti 16GB" → "RTX 5060 Ti" by finding the longest match
 var best = -1;
 for (var i = 0; i < GPU_TIER.length; i++) {
 if (str.indexOf(GPU_TIER[i]) !== -1 && (best === -1 || GPU_TIER[i].length > GPU_TIER[best].length)) {
 best = i;
 }
 }
 return best;
 }

 // Calculate price diff up front for use in price point AND bottom line.
 // Default to 0 if either price is missing.
 var hasValidPrices = typeof lowSys.priceNum === 'number' && typeof highSys.priceNum === 'number'
 && lowSys.priceNum > 0 && highSys.priceNum > 0;
 var priceDiff = hasValidPrices ? (highSys.priceNum - lowSys.priceNum) : 0;

 // ── 1. PRICE ── only include if both systems have real prices
 if (hasValidPrices) {
 var pctMore = Math.round(priceDiff / lowSys.priceNum * 100);
 points.push({
 icon: '💰',
 text: `The ${highSys.name} costs $${priceDiff.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})} more than the ${lowSys.name} (${pctMore}% increase).`
 });
 }

 // ── 2. PROCESSOR ── compare CPUs by generation, family tier, and X3D cache.
 // Silent if both CPUs are identical or unrecognizable.
 var lowCpu = parseRyzen(lowSys.specs.Processor);
 var highCpu = parseRyzen(highSys.specs.Processor);
 if (lowCpu && highCpu && (lowCpu.raw !== highCpu.raw)) {
 // Detect what changed
 var genJump = highCpu.gen > lowCpu.gen;
 var familyJump = highCpu.family > lowCpu.family;
 var x3dGain = highCpu.x3d && !lowCpu.x3d;
 var x3dLost = !highCpu.x3d && lowCpu.x3d;
 var cpuMsg = '';
 if (x3dGain && genJump) {
 cpuMsg = `The ${highSys.name} steps up to the ${highCpu.raw}, a Zen ${highCpu.gen} chip with 3D V-Cache. For gaming, the cache delivers a measurable lift (often 10–20%) over a non-X3D part at the same clocks.`;
 } else if (x3dGain) {
 cpuMsg = `The ${highSys.name} adds 3D V-Cache (${highCpu.raw}). In CPU-bound games, the extra cache is worth more than a generation of clock-speed gains.`;
 } else if (genJump && familyJump) {
 cpuMsg = `The ${highSys.name} pairs a newer Zen ${highCpu.gen} architecture with a higher-tier Ryzen ${highCpu.family} part. More cores and higher per-clock performance for productivity work alongside gaming.`;
 } else if (genJump) {
 cpuMsg = `The ${highSys.name} runs on Zen ${highCpu.gen} (${highCpu.raw}) versus Zen ${lowCpu.gen} (${lowCpu.raw}). Newer architecture means higher clocks and improved per-clock efficiency.`;
 } else if (familyJump) {
 cpuMsg = `The ${highSys.name} steps up to a Ryzen ${highCpu.family} (${highCpu.raw}). More cores helps in streaming, content creation, and games that scale beyond six cores.`;
 } else if (x3dLost) {
 // Edge case: cheaper system has X3D, pricier doesn't (unusual but handle it).
 cpuMsg = `The ${lowSys.name} carries the 3D V-Cache part. In pure gaming workloads it can match or exceed the ${highSys.name}'s CPU despite being cheaper.`;
 } else {
 // Same gen, same family, different model — minor refresh
 cpuMsg = `Both systems use Zen ${highCpu.gen} silicon, with the ${highSys.name} on the ${highCpu.raw} versus the ${lowCpu.raw}. The difference shows up at the margins, not in everyday gaming.`;
 }
 points.push({ icon: '⚙️', text: cpuMsg });
 }

 // ── 3. PLATFORM ── only if different
 if (lowSys.specs.Platform && highSys.specs.Platform && lowSys.specs.Platform !== highSys.specs.Platform) {
 var isAm5Jump = /AM5/.test(highSys.specs.Platform) && /AM4/.test(lowSys.specs.Platform);
 if (isAm5Jump) {
 points.push({
 icon: '🔧',
 text: `Moving from ${lowSys.specs.Platform} to ${highSys.specs.Platform} brings DDR5 memory and a current-generation socket. The ${highSys.name} can be upgraded to newer Ryzen chips for years without replacing the motherboard.`
 });
 } else {
 points.push({
 icon: '🔧',
 text: `The ${highSys.name} runs on ${highSys.specs.Platform} versus ${lowSys.specs.Platform} on the ${lowSys.name}. Different sockets mean different upgrade paths down the line.`
 });
 }
 }

 // ── 4. GPU CLASS ── only mention if there's a tier jump bigger than VRAM alone captures
 var lowGpuT = gpuTier(lowSys.specs.Graphics);
 var highGpuT = gpuTier(highSys.specs.Graphics);
 if (lowGpuT >= 0 && highGpuT >= 0 && highGpuT - lowGpuT >= 2) {
 var gpuJump = highGpuT - lowGpuT;
 // Rough rasterization multiplier per tier step. Calibrated against
 // published benchmarks: each ladder step averages 20-30% more raw
 // performance, with bigger jumps at the top end (5070 Ti → 5080 → 5090).
 var rawMult;
 if (gpuJump === 2) rawMult = '1.5–1.8×';
 else if (gpuJump === 3) rawMult = '1.8–2.3×';
 else if (gpuJump === 4) rawMult = '2.3–2.8×';
 else rawMult = '2.5–3.5×';
 var gpuClassMsg = gpuJump >= 4
 ? `The ${highSys.name} runs the ${gpuShort(highSys.specs.Graphics)}, in a different performance class entirely from the ${gpuShort(lowSys.specs.Graphics)}. Expect roughly ${rawMult} the raw frame rate in modern AAA titles before any upscaling.`
 : `The ${highSys.name} steps ${gpuJump} tiers up the GPU ladder (${gpuShort(highSys.specs.Graphics)} vs ${gpuShort(lowSys.specs.Graphics)}). Expect roughly ${rawMult} the raw frame rate in modern AAA titles before any upscaling.`;
 points.push({ icon: '🎮', text: gpuClassMsg });
 }

 // ── 5. VRAM ── only mention if VRAM is the meaningful difference
 // (skipped when GPU class jump above already covered the gap, except when
 // VRAM tells a story the class jump doesn't, like 8GB → 16GB on adjacent tiers)
 var lowVRAM = vramGB(lowSys.specs.VRAM);
 var highVRAM = vramGB(highSys.specs.VRAM);
 var gpuClassReported = (lowGpuT >= 0 && highGpuT >= 0 && highGpuT - lowGpuT >= 2);
 if (lowVRAM && highVRAM && highVRAM > lowVRAM && (!gpuClassReported || (highVRAM - lowVRAM) >= 8)) {
 var vramDiff = highVRAM - lowVRAM;
 var vramHelp = '';
 if (highVRAM >= 16) vramHelp = ' At 16GB or more, no current game will run out of VRAM at any resolution.';
 else if (highVRAM >= 12) vramHelp = ' 12GB is comfortable for 1440p and most 4K scenarios.';
 else vramHelp = ' Both systems have enough VRAM for 1080p, but mods and high-resolution textures benefit from more.';
 points.push({
 icon: '📦',
 text: `The ${highSys.name} has ${vramDiff}GB more VRAM (${highVRAM}GB vs ${lowVRAM}GB).${vramHelp}`
 });
 }

 // ── 6. UPSCALING / FRAME GEN ── compare the upscaling tech available on each GPU.
 // Frame gen presence vs absence is itself meaningful (a 0.5 tier delta), so
 // we trigger on any positive delta rather than only large jumps.
 var lowFG = upscaleTier(lowSys.specs.FrameGen);
 var highFG = upscaleTier(highSys.specs.FrameGen);
 if (highFG > lowFG) {
 var fgMsg = '';
 if (highFG === 4 && lowFG <= 1) {
 fgMsg = `The ${highSys.name} unlocks DLSS 4 with Multi Frame Generation (RTX 50-series only). On supported titles this roughly doubles frame rate over the upscaling on the ${lowSys.name}.`;
 } else if (highFG === 4 && lowFG === 2.5) {
 fgMsg = `Both systems have frame generation, but the ${highSys.name} runs DLSS 4 MFG (2× FG) versus XeSS 2 with single frame gen on the ${lowSys.name}. The DLSS 4 path produces a substantially higher post-FG frame rate in supported games.`;
 } else if (highFG === 4) {
 fgMsg = `The ${highSys.name} adds DLSS 4 Multi Frame Generation. In titles that support it, the displayed frame rate roughly doubles relative to upscaling alone.`;
 } else if (highFG === 2.5 && lowFG === 2) {
 fgMsg = `The Arc B580 in the ${highSys.name} adds XeSS 2 frame generation. The Arc A750 in the ${lowSys.name} supports XeSS upscaling but not frame gen, so its uplift caps at the SR-only path.`;
 } else if (highFG === 2.5 && lowFG <= 1) {
 fgMsg = `The Arc B580 in the ${highSys.name} adds XeSS 2 frame generation. The ${lowSys.name}'s GPU does not support frame gen, so its upscaling caps at the SR-only uplift.`;
 } else {
 fgMsg = `The ${highSys.name}'s GPU supports a more capable upscaling stack than the ${lowSys.name}'s. In titles that use it, the post-upscale frame rate is meaningfully higher.`;
 }
 points.push({ icon: '✨', text: fgMsg });
 }

 // ── 7. MEMORY ── compare both size and type, including unusual cases
 var lowMem = memGB(lowSys.specs.Memory);
 var highMem = memGB(highSys.specs.Memory);
 var lowMemType = memType(lowSys.specs.Memory);
 var highMemType = memType(highSys.specs.Memory);
 if (lowMem && highMem) {
 var typesKnown = lowMemType && highMemType;
 var typeChanged = typesKnown && lowMemType !== highMemType;
 if (highMem > lowMem && typeChanged) {
 // Both more capacity AND newer type
 points.push({
 icon: '🧠',
 text: `The ${highSys.name} pairs ${highMem}GB of ${highMemType} with the newer platform. Faster memory plus more capacity helps in modern games and multitasking.`
 });
 } else if (highMem > lowMem) {
 var ratio = (highMem / lowMem).toFixed(1).replace(/\.0$/,'');
 var memNote = highMem >= 32
 ? ' At 32GB you can game, stream, and keep dozens of tabs open without slowdown.'
 : ' Helpful for streaming, alt-tabbing, and games that benefit from more headroom.';
 points.push({
 icon: '🧠',
 text: `The ${highSys.name} has ${ratio}x the memory (${highMem}GB vs ${lowMem}GB).${memNote}`
 });
 } else if (highMem === lowMem && typeChanged) {
 // Same capacity, newer type (e.g. 16GB DDR4 → 16GB DDR5)
 points.push({
 icon: '🧠',
 text: `Both systems carry ${highMem}GB, but the ${highSys.name} uses ${highMemType} versus ${lowMemType}. Faster memory translates to higher minimum frame rates in CPU-bound games.`
 });
 } else if (highMem < lowMem && typeChanged) {
 // Lower capacity but newer type (e.g. 32GB DDR4 → 16GB DDR5)
 points.push({
 icon: '🧠',
 text: `The ${highSys.name} carries ${highMem}GB of ${highMemType} versus ${lowMem}GB of ${lowMemType} on the ${lowSys.name}. The newer memory is significantly faster, though the lower capacity means less headroom for heavy multitasking.`
 });
 }
 }

 // ── 8. STORAGE ── only mention if there's a meaningful capacity difference
 var lowStor = storageGB(lowSys.specs.Storage);
 var highStor = storageGB(highSys.specs.Storage);
 if (lowStor && highStor && highStor > lowStor) {
 var lowLabel = lowStor >= 1000 ? (lowStor/1000) + 'TB' : lowStor + 'GB';
 var highLabel = highStor >= 1000 ? (highStor/1000) + 'TB' : highStor + 'GB';
 points.push({
 icon: '💾',
 text: `The ${highSys.name} ships with ${highLabel} of storage versus ${lowLabel}. Modern AAA titles regularly hit 100GB each, so the extra space adds up fast.`
 });
 }

 // ── 9. COOLING ── only mention if upgrading from air to AIO
 var lowCool = String(lowSys.specs.Cooling||'').toLowerCase();
 var highCool = String(highSys.specs.Cooling||'').toLowerCase();
 if (lowCool && highCool && /air|tower/.test(lowCool) && /aio|liquid|mm/.test(highCool)) {
 points.push({
 icon: '❄️',
 text: `The ${highSys.name} uses an AIO liquid cooler versus the air cooler in the ${lowSys.name}. The AIO is quieter under load and keeps high-TDP CPUs from throttling during long gaming sessions.`
 });
 }

 // ── 10. TARGET / DISPLAY MATCH ── only call out if resolutions differ;
 // refresh-rate-only differences aren't worth a full point.
 if (lowSys.target && highSys.target && lowSys.target !== highSys.target) {
 function extractRes(t) { var m = String(t).match(/(\d+p)/g); return m ? m.join('-') : ''; }
 var lowRes = extractRes(lowSys.target);
 var highRes = extractRes(highSys.target);
 if (lowRes !== highRes) {
 points.push({
 icon: '🖥️',
 text: `The ${lowSys.name} is built for ${lowSys.target}. The ${highSys.name} is built for ${highSys.target}. Pair each system with a monitor that matches its target resolution to get the most out of it.`
 });
 } else {
 // Same resolution, different refresh rate
 points.push({
 icon: '🖥️',
 text: `Both systems target ${lowRes}, but the ${highSys.name} drives higher refresh rates. If you have or plan to buy a high-refresh monitor, the extra frames matter.`
 });
 }
 }

 // ── 11. RESOLUTION FIT ── grounded in the actual GPU + VRAM combination
 // rather than the marketing target. Helps the buyer match a system to
 // the monitor they actually own. Skipped when it would just repeat the
 // marketing target (which is rendered in section 10).
 function resoFit(gpuTierIdx, vramAmt) {
 // Below RTX 5060 Ti tier or under 12GB VRAM: 1080p territory.
 if (gpuTierIdx < 4 || (vramAmt && vramAmt < 12)) return '1080p';
 // 5060 Ti / 5070 with 12-16GB: 1440p sweet spot, occasional 4K.
 if (gpuTierIdx <= 5 || (vramAmt && vramAmt < 16)) return '1440p';
 // 5070 Ti / 5080: 1440p high refresh, 4K capable.
 if (gpuTierIdx <= 7) return '1440p high refresh, 4K capable';
 // 5090: 4K territory.
 return '4K with headroom';
 }
 if (lowGpuT >= 0 && highGpuT >= 0) {
 var lowFit = resoFit(lowGpuT, lowVRAM);
 var highFit = resoFit(highGpuT, highVRAM);
 if (lowFit !== highFit) {
 points.push({
 icon: '🎯',
 text: `Where each system actually shines: the ${lowSys.name} is at home at ${lowFit}, the ${highSys.name} at ${highFit}. Pick the one that matches the monitor you have or plan to buy.`
 });
 }
 }

 // ── 12. LONGEVITY / UPGRADE OUTLOOK ── only if there's something real
 // to say about how long the high system will stay current.
 var longevityNote = '';
 var lowOnAm5 = /AM5/.test(String(lowSys.specs.Platform||''));
 var highOnAm5 = /AM5/.test(String(highSys.specs.Platform||''));
 if (highOnAm5 && !lowOnAm5) {
 longevityNote = `The ${highSys.name} is on AM5, AMD's current socket. AMD has stated AM5 will receive new CPUs at least through 2027, so a CPU upgrade later is a chip swap rather than a motherboard replacement.`;
 } else if (highOnAm5 && lowOnAm5 && highCpu && lowCpu && highCpu.gen > lowCpu.gen) {
 longevityNote = `Both systems are on AM5, so both have a long upgrade runway. The ${highSys.name} starts a generation ahead, which buys roughly two more years before a CPU swap becomes worth considering.`;
 } else if (highGpuT >= 6 && lowGpuT >= 0 && lowGpuT < 4) {
 longevityNote = `The ${highSys.name}'s GPU will hold up for the next two generations of demanding AAA releases without needing settings cuts. The ${lowSys.name}'s GPU is current today but will need lower settings or DLSS Performance mode by year three.`;
 }
 if (longevityNote) points.push({ icon: '🔮', text: longevityNote });

 // ── 13. USE CASE ── give the buyer a sense of who each system best serves,
 // not just "spec is bigger." Memory + CPU + storage capacity together
 // hint at workloads beyond pure gaming.
 var useCaseNote = '';
 var highMemBig = highMem && highMem >= 32;
 var lowMemBig = lowMem && lowMem >= 32;
 var highX3D = highCpu && highCpu.x3d;
 var lowX3D = lowCpu && lowCpu.x3d;
 var highStorBig = highStor && highStor >= 2000;
 if (highMemBig && !lowMemBig && highX3D && !lowX3D) {
 useCaseNote = `Beyond gaming: with 32GB and an X3D chip, the ${highSys.name} comfortably handles streaming alongside gaming, video editing, and dozens of open browser tabs. The ${lowSys.name} is built for one job at a time.`;
 } else if (highMemBig && !lowMemBig) {
 useCaseNote = `For multitasking: 32GB on the ${highSys.name} versus ${lowMem}GB on the ${lowSys.name}. If you stream while gaming, edit video, or keep heavy creative apps open, the extra capacity prevents stutter from page-file thrashing.`;
 } else if (highX3D && !lowX3D) {
 useCaseNote = `For pure gaming: the X3D cache on the ${highSys.name}'s CPU directly translates to higher minimum frame rates in CPU-bound games like simulators, MMOs, and competitive shooters. Less impact on productivity workloads.`;
 } else if (highStorBig && (!lowStor || lowStor < 2000)) {
 useCaseNote = `Library size: ${highStor/1000}TB on the ${highSys.name} fits roughly 20-25 modern AAA titles installed at once. Useful if you switch games often without wanting to redownload.`;
 }
 if (useCaseNote) points.push({ icon: '🎮', text: useCaseNote });

 // ── 14. COUNTER-INTUITIVE WINS ── when a row in the comparison table turns
 // green for the cheaper system, that can mislead. Call those out so the
 // buyer doesn't read it as "the cheaper one is the better system."
 var counterPoints = [];
 // Pro X's 16GB VRAM > Ultra's 12GB. RTX 5070 is still faster overall than RTX 5060 Ti.
 if (lowVRAM && highVRAM && lowVRAM > highVRAM && lowGpuT >= 0 && highGpuT > lowGpuT) {
 counterPoints.push(`The ${lowSys.name} has more VRAM (${lowVRAM}GB vs ${highVRAM}GB), but the ${highSys.name}'s GPU is faster overall. In most modern titles, raw GPU speed matters more than the extra VRAM until you hit 4K with heavy textures.`);
 }
 // Pro X 32GB DDR4 vs Ultra 16GB DDR5: capacity wins on the comparison
 // table, but the platform/CPU/memory speed advantage is on the high side.
 if (lowMem && highMem && lowMem > highMem && lowMemType === 'DDR4' && highMemType === 'DDR5') {
 counterPoints.push(`The ${lowSys.name} has more total memory (${lowMem}GB vs ${highMem}GB), but the ${highSys.name}'s DDR5 runs at roughly 1.5x the bandwidth and pairs with a current-gen platform. Capacity matters for multitasking; memory speed matters for frame rates.`);
 }
 if (counterPoints.length) {
 points.push({ icon: '⚖️', text: 'Worth noting: ' + counterPoints.join(' Also: ') });
 }

 // ── 15. THE BOTTOM LINE ── synthesized takeaway. With the new dimensions
 // there's more signal to work with, so this picks one of several
 // archetypes based on what actually changed.
 var dimensionsChanged = points.length - (hasValidPrices ? 1 : 0);
 var bigGpuJump = (lowGpuT >= 0 && highGpuT >= 0 && highGpuT - lowGpuT >= 3);
 var platformJump = (lowOnAm5 !== highOnAm5);
 var bottomLine = '';
 if (!hasValidPrices) {
 if (dimensionsChanged === 0) {
 bottomLine = `These systems are functionally identical on the specs tracked here.`;
 } else if (dimensionsChanged >= 6) {
 bottomLine = `The ${highSys.name} is not an incremental upgrade. It is a different class of machine.`;
 } else {
 bottomLine = `The ${highSys.name} steps up across ${dimensionsChanged} spec dimension${dimensionsChanged === 1 ? '' : 's'}.`;
 }
 } else if (priceDiff <= 250 && dimensionsChanged <= 2) {
 bottomLine = `For the price gap, the ${highSys.name} is a modest step up. If budget is tight, the ${lowSys.name} covers the same use cases with minor compromises.`;
 } else if (bigGpuJump && platformJump) {
 bottomLine = `The ${highSys.name} earns its premium with a new platform AND a meaningful GPU class jump. Best fit for buyers who want a system that stays current for 4-5 years without major upgrades.`;
 } else if (bigGpuJump) {
 bottomLine = `The GPU class jump is the headline here. Choose the ${highSys.name} if you game at 1440p or higher, or want headroom for the next round of demanding releases.`;
 } else if (platformJump) {
 bottomLine = `The platform jump (AM4 to AM5) is the real story. Choose the ${highSys.name} if you want a CPU upgrade path that extends past 2027.`;
 } else if (dimensionsChanged >= 6) {
 bottomLine = `The ${highSys.name} is comprehensively a tier above. Worth it if you plan to keep the system 4+ years and want to avoid a mid-life upgrade.`;
 } else {
 bottomLine = `The ${highSys.name} earns its price gap in the dimensions that matter most for longevity. The ${lowSys.name} stays the safer pick for tighter budgets.`;
 }
 points.push({ icon: '✓', text: bottomLine });

 return points;
}

// ── Build compare UI
function buildCompareContent() {
 const systems = selected
 .map(k => ({ key: k, sys: SYSTEMS[k] }))
 .sort((a, b) => a.sys.priceNum - b.sys.priceNum);
 const n = systems.length;
 const isMobile = window.innerWidth <= 860;
 const labelCol = isMobile ? '72px' : '140px';
 const dataMinW = isMobile ? '90px' : '130px';
 const gridCols = `${labelCol} ${`minmax(${dataMinW},1fr) `.repeat(n)}`.trim();
 const minTableW = `min-width:${140 + n * 140}px;`;

 const estimatorKeys = systems.map(s => s.key);
 const hasDlss4 = estimatorKeys.some(k => ['pro','prox','ultra','ultrax','max'].includes(k));
 // hasXeSS now covers BOTH Core (Arc A750, XeSS 1) and Core X (Arc B580, XeSS 2 with Frame Gen)
 const hasXeSS = estimatorKeys.some(k => k === 'core' || k === 'corex');
 const hasXeSSFG = estimatorKeys.some(k => k === 'corex'); // B580 supports XeSS 2 Frame Gen
 let upscaleOptions = '<option value="native">Native (no upscaling)</option>';
 upscaleOptions += '<option value="sr">Upscaling only (SR balanced)</option>';
 if (hasXeSS) upscaleOptions += '<option value="xess">XeSS SR (Arc)</option>';
 if (hasXeSSFG) upscaleOptions += '<option value="xessfg">XeSS 2 + Frame Gen 1× (Arc B580)</option>';
 if (hasDlss4) upscaleOptions += '<option value="dlss4mfg" selected>DLSS 4 + Multi Frame Gen 2× (RTX 50 series)</option>';
 else if (hasXeSSFG) upscaleOptions = upscaleOptions.replace('<option value="xessfg">', '<option value="xessfg" selected>');
 else if (hasXeSS) upscaleOptions = upscaleOptions.replace('<option value="xess">', '<option value="xess" selected>');
 else upscaleOptions = upscaleOptions.replace('<option value="sr">', '<option value="sr" selected>');

 document.getElementById('compareSubtitle').textContent =
 systems.map(s => s.sys.name).join(' vs ');

 const specRows = [
 { key: 'Processor', label: 'Processor' },
 { key: 'Graphics', label: 'Graphics' },
 { key: 'VRAM', label: 'VRAM' },
 { key: 'Memory', label: 'Memory' },
 { key: 'Storage', label: 'Storage' },
 { key: 'Cooling', label: 'Cooling' },
 { key: 'Platform', label: 'Platform' },
 { key: 'FrameGen', label: 'Upscaling' },
 ];

 // Component ranking ladders. Lower index = lower tier. Each list contains
 // every value that can appear in the corresponding spec field, so a value
 // not in the list signals stale data and disables green highlighting (we'd
 // rather show no winner than a wrong one).
 //
 // For Memory, Storage and VRAM we don't use these lists — they're scored
 // numerically below so capacity comparisons keep working when SKUs change.
 const RANKINGS = {
 Processor: [
 // AM4 Zen 3
 'Ryzen 5 5500','Ryzen 5 5600','Ryzen 5 5600X','Ryzen 5 5700X','Ryzen 7 5700X','Ryzen 7 5800X','Ryzen 7 5800X3D',
 // AM5 Zen 4
 'Ryzen 5 7600','Ryzen 5 7600X','Ryzen 7 7700','Ryzen 7 7700X','Ryzen 7 7800X3D',
 // AM5 Zen 5
 'Ryzen 5 9600X','Ryzen 7 9700X','Ryzen 7 9800X3D',
 ],
 Graphics: [
 // Entry (matches `spec:Graphics` values without VRAM suffix)
 'RX 6600','Arc A750','Arc B580','RTX 5060',
 // Mid (RTX 5070 is faster than 5060 Ti overall; the 5060 Ti 16GB has a VRAM
 // advantage in a handful of high-texture titles but loses on raster speed)
 'RTX 5060 Ti','RTX 5070',
 // High
 'RTX 5070 Ti','RTX 5080','RTX 5090',
 ],
 Cooling: [
 // Air at the bottom; AIO sizes ordered by radiator (more = better thermals)
 'Air','120mm AIO','240mm AIO','280mm AIO','360mm AIO','420mm AIO',
 ],
 Platform: ['AM4 / DDR4','AM5 / DDR5'],
 FrameGen: [
 // Lower upscaling capability → higher
 'FSR SR','XeSS SR','XeSS 2 SR + FG','DLSS3 SR + FG','DLSS4 SR + MFG 2×',
 ],
 };

 // Helper: extract a number with units (TB/GB/mm) and convert to a comparable
 // numeric. Returns null if no quantity found.
 function _capacityValue(s) {
 var str = String(s||'').toLowerCase();
 // 2x16GB → 32
 var kit = str.match(/(\d+)\s*[x×]\s*(\d+)\s*gb/);
 if (kit) return parseInt(kit[1],10) * parseInt(kit[2],10);
 // TB to GB
 var tb = str.match(/(\d+(?:\.\d+)?)\s*tb/);
 if (tb) return parseFloat(tb[1]) * 1000;
 // GB
 var gb = str.match(/(\d+(?:\.\d+)?)\s*gb/);
 if (gb) return parseFloat(gb[1]);
 // mm radiator (used for cooling fallback when ranking misses)
 var mm = str.match(/(\d+)\s*mm/);
 if (mm) return parseInt(mm[1],10);
 return null;
 }

 // Returns the index of the strict winner, or -1 if there's a tie or
 // a value that can't be ranked. For capacity-style specs (Memory,
 // Storage, VRAM) it ranks numerically. For Memory it also breaks
 // capacity ties by DDR generation (DDR5 > DDR4). For component
 // models it consults RANKINGS.
 function bestIdx(vals, specKey) {
 // Capacity-style specs: pure numeric ranking.
 if (specKey === 'VRAM' || specKey === 'Storage' || specKey === 'Memory') {
 var caps = vals.map(_capacityValue);
 if (caps.some(function(v) { return v === null; })) return -1;
 // For Memory, also consider DDR generation when capacity ties.
 if (specKey === 'Memory') {
 var ddrs = vals.map(function(v) {
 var m = String(v||'').match(/ddr(\d)/i);
 return m ? parseInt(m[1],10) : 0;
 });
 // Memory has two axes: capacity and DDR generation. Picking a winner
 // requires both to agree (or one tie). If the bigger-capacity system
 // has the older DDR generation (e.g. 32GB DDR4 vs 16GB DDR5), call it
 // a tie — neither is unambiguously better for gaming.
 var maxCap = Math.max.apply(null, caps);
 var maxDdr = Math.max.apply(null, ddrs);
 var capWinners = [];
 var ddrWinners = [];
 for (var ci = 0; ci < caps.length; ci++) {
 if (caps[ci] === maxCap) capWinners.push(ci);
 if (ddrs[ci] === maxDdr) ddrWinners.push(ci);
 }
 // If a single system wins on both capacity and DDR, that's the winner.
 // Otherwise: tie (no green highlight).
 var bothWin = capWinners.filter(function(i) { return ddrWinners.indexOf(i) !== -1; });
 if (bothWin.length === 1) return bothWin[0];
 return -1;
 }
 var maxCap = Math.max.apply(null, caps);
 var maxCount = caps.filter(function(c) { return c === maxCap; }).length;
 return maxCount > 1 ? -1 : caps.indexOf(maxCap);
 }
 // Cooling: try ranking first, fall back to mm radiator size for unknown AIOs.
 if (specKey === 'Cooling') {
 var rank = RANKINGS.Cooling;
 var idxs = vals.map(function(v) { return rank.indexOf(String(v||'').trim()); });
 if (idxs.every(function(i) { return i !== -1; })) {
 var mx = Math.max.apply(null, idxs);
 var mc = idxs.filter(function(i) { return i === mx; }).length;
 return mc > 1 ? -1 : idxs.indexOf(mx);
 }
 // Fall back: any AIO beats Air; among AIOs, larger mm wins. Air coolers
 // score 100 — match named brands too (Pure Rock, Wraith, NH-D15, etc.)
 // since live spec values often don't carry the literal word "air".
 var scores = vals.map(function(v) {
 var s = String(v||'').toLowerCase();
 if (/aio|liquid/.test(s)) {
 var mm = s.match(/(\d+)\s*mm/);
 return mm ? 1000 + parseInt(mm[1],10) : 1000;
 }
 // Treat anything that isn't liquid as an air cooler if it has any value.
 // The named-cooler heuristic (rock|noctua|wraith|hyper|nh-|peerless|...)
 // covers the popular brands, but we also default to 100 for any
 // non-empty non-AIO value rather than 0, since gaming PCs always ship
 // with some form of cooling.
 if (s) return 100;
 return 0;
 });
 var mxs = Math.max.apply(null, scores);
 if (mxs === 0) return -1;
 var mcs = scores.filter(function(s) { return s === mxs; }).length;
 return mcs > 1 ? -1 : scores.indexOf(mxs);
 }
 // Component models: consult RANKINGS list. Use case-insensitive
 // longest-substring match so live spec values that include vendor
 // prefixes ("AMD Ryzen 5 5500", "GeForce RTX 5060 8GB", "Intel ARC A750")
 // still resolve to the correct ranking entry.
 var list = RANKINGS[specKey];
 if (list) {
 var indices = vals.map(function(v) {
 var str = String(v||'').trim().toLowerCase();
 var bestI = -1;
 var bestLen = 0;
 for (var li = 0; li < list.length; li++) {
 var entry = list[li].toLowerCase();
 if (str.indexOf(entry) !== -1 && entry.length > bestLen) {
 bestI = li;
 bestLen = entry.length;
 }
 }
 return bestI;
 });
 if (indices.some(function(i) { return i === -1; })) return -1;
 var max = Math.max.apply(null, indices);
 var maxCount = indices.filter(function(i) { return i === max; }).length;
 return maxCount > 1 ? -1 : indices.indexOf(max);
 }
 // Last-resort numeric extraction.
 var nums = vals.map(function(v) { return parseFloat(v); });
 if (nums.some(isNaN)) return -1;
 var mx2 = Math.max.apply(null, nums);
 var mc2 = nums.filter(function(n) { return n === mx2; }).length;
 return mc2 > 1 ? -1 : nums.indexOf(mx2);
 }

 const colors = ['#0071e3', '#30d158', '#ff9f0a', '#ff453a'];

 let html = '';

 html += `<div class="cm-system-headers" style="grid-template-columns:${gridCols}; display:grid; ${minTableW}">
 <div></div>
 ${systems.map((s,i) => `
 <div class="cm-system-header">
 <span class="cm-system-tag">${s.sys.badge || ''}</span>
 <span class="cm-system-name">${s.sys.name || '?'}</span>
 <span class="cm-system-price">${(typeof s.sys.priceNum === 'number' && s.sys.priceNum > 0) ? '$'+s.sys.priceNum.toLocaleString('en-US', {minimumFractionDigits:2}) : '—'}</span>
 </div>`).join('')}
 </div>`;

 html += `<div class="cm-section">
 <div class="cm-section-title">Hardware</div>`;

 specRows.forEach(row => {
 const vals = systems.map(s => String(s.sys.specs[row.key] ?? '—'));
 const bi = bestIdx(vals, row.key);
 html += `<div class="cm-row" style="grid-template-columns:${gridCols}; display:grid; ${minTableW}">
 <span class="cm-label">${row.label}</span>
 ${vals.map((v, i) => {
 const cls = (bi >= 0 && i === bi) ? 'cm-val best' : 'cm-val';
 return `<span class="${cls}">${v}</span>`;
 }).join('')}
 </div>`;
 });

 html += `</div>`;

 html += '<div class="cm-section" style="border-top:2px solid var(--accent); background:rgba(0,113,227,0.02); padding-bottom:4px;">' +
 '<div class="cm-section-title" style="color:var(--accent); padding-top:16px;">Try Your Game</div>' +
 '<div style="padding:4px 0 12px; font-size:13px; color:var(--text-secondary); line-height:1.5;">Estimate FPS for any game on these systems. Uses <strong>High settings</strong>, each build\'s target display by default.</div>' +
 '<div style="display:flex; flex-direction:column; gap:10px; padding-bottom:20px;">' +
 '<div style="display:flex; gap:8px; flex-wrap:wrap;">' +
 '<div style="display:flex; flex-direction:column; gap:4px; flex:1; min-width:140px;">' +
 '<label style="font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:0.06em; color:var(--text-tertiary);">Game title</label>' +
 '<input id="cmGameInput" type="text" placeholder="e.g. Elden Ring, Valorant, Cyberpunk…" oninput="cmClearGenre()"' +
 ' style="width:100%; border:1px solid var(--light-gray); border-radius:8px; padding:10px 14px; font-size:14px; font-family:inherit; outline:none; color:var(--text); background:var(--white);">' +
 '</div>' +
 '<div style="display:flex; flex-direction:column; gap:4px; flex:1; min-width:140px;">' +
 '<label style="font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:0.06em; color:var(--text-tertiary);">Or pick a genre</label>' +
 '<select id="cmGamePreset" onchange="cmClearInput()"' +
 ' style="width:100%; border:1px solid var(--light-gray); border-radius:8px; padding:10px 12px; font-size:13px; font-family:inherit; outline:none; color:var(--text); background:var(--white);">' +
 '<option value="">— or pick a genre —</option>' +
 '<option value="esports">Esports (Valorant, CS2, R6…)</option>' +
 '<option value="competitive">Competitive Shooter (CoD, Apex…)</option>' +
 '<option value="openworld">Open-World AAA (Cyberpunk, RDR2…)</option>' +
 '<option value="rpg">RPG / Adventure (Elden Ring, BG3…)</option>' +
 '<option value="survival">Survival / Crafting (Valheim, ARK…)</option>' +
 '<option value="racing">Racing / Sim (Forza, F1…)</option>' +
 '<option value="strategy">Strategy / RTS (Civ, Stellaris…)</option>' +
 '<option value="horror">Horror (RE, Dead Space, SH2…)</option>' +
 '<option value="mmo">MMO / Online RPG (WoW, FFXIV, PoE…)</option>' +
 '<option value="indie">Indie / Platformer (Hades, Hollow Knight…)</option>' +
 '<option value="battleroyale">Battle Royale (Fortnite, Warzone…)</option>' +
 '<option value="zombie">Zombie / Co-op (L4D2, Darktide…)</option>' +
 '<option value="sports">Sports (FC 25, NBA 2K…)</option>' +
 '<option value="puzzle">Puzzle / Narrative (Detroit, Talos…)</option>' +
 '<option value="sim">Simulator (MSFS, DCS, BeamNG…)</option>' +
 '</select>' +
 '</div>' +
 '</div>' +
 '<div style="display:flex; gap:8px; flex-wrap:wrap; align-items:flex-end;">' +
 '<div style="display:flex; flex-direction:column; gap:4px; flex:0 0 auto;">' +
 '<label style="font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:0.06em; color:var(--text-tertiary);">Resolution</label>' +
 '<select id="cmResolution"' +
 ' style="border:1px solid var(--light-gray); border-radius:8px; padding:10px 12px; font-size:13px; font-family:inherit; outline:none; color:var(--text); background:var(--white);">' +
 '<option value="auto" selected>Each build\'s target</option>' +
 '<option value="1080p">1080p (override)</option>' +
 '<option value="1440p">1440p (override)</option>' +
 '<option value="4k">4K (override)</option>' +
 '</select>' +
 '</div>' +
 '<div style="display:flex; flex-direction:column; gap:4px; flex:1; min-width:160px;">' +
 '<label style="font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:0.06em; color:var(--text-tertiary);">Upscaling mode</label>' +
 '<select id="cmUpscaleMode"' +
 ' style="width:100%; border:1px solid var(--light-gray); border-radius:8px; padding:10px 12px; font-size:13px; font-family:inherit; outline:none; color:var(--text); background:var(--white);">' +
 upscaleOptions +
 '</select>' +
 '</div>' +
 '<button onclick="estimateCustomGame()"' +
 ' style="background:var(--accent); color:white; border:none; border-radius:8px; padding:11px 22px; font-size:14px; font-weight:600; cursor:pointer; font-family:inherit; white-space:nowrap; flex-shrink:0;">Estimate FPS</button>' +
 '</div>' +
 '<div id="cmGameResult"></div>' +
 '</div>' +
 '</div>';

 // Analysis: works for 2 or 3 systems. For 3, run pairwise on neighboring tiers
 // (cheap→mid, mid→top) so the middle system isn't ignored.
 if (n === 2) {
 const points = generateAnalysis(systems);
 html += `<div class="cm-analysis">
 <div class="cm-analysis-title">Our Analysis</div>
 <div class="cm-analysis-points">
 ${points.map(p => `<div class="cm-point"><span class="cm-point-icon">${p.icon}</span><span>${p.text}</span></div>`).join('')}
 </div>
 </div>`;
 } else if (n === 3) {
 const sortedByPrice = [...systems].sort((a,b) => a.sys.priceNum - b.sys.priceNum);
 const stepUpA = generateAnalysis([sortedByPrice[0], sortedByPrice[1]]);
 const stepUpB = generateAnalysis([sortedByPrice[1], sortedByPrice[2]]);
 html += `<div class="cm-analysis">
 <div class="cm-analysis-title">${sortedByPrice[0].sys.name} → ${sortedByPrice[1].sys.name}</div>
 <div class="cm-analysis-points">
 ${stepUpA.map(p => `<div class="cm-point"><span class="cm-point-icon">${p.icon}</span><span>${p.text}</span></div>`).join('')}
 </div>
 </div>`;
 html += `<div class="cm-analysis" style="margin-top:24px;">
 <div class="cm-analysis-title">${sortedByPrice[1].sys.name} → ${sortedByPrice[2].sys.name}</div>
 <div class="cm-analysis-points">
 ${stepUpB.map(p => `<div class="cm-point"><span class="cm-point-icon">${p.icon}</span><span>${p.text}</span></div>`).join('')}
 </div>
 </div>`;
 }

 html += `<div style="height:16px;"></div>`;

 document.getElementById('compareContent').innerHTML =
 '<div style="overflow-x:auto; -webkit-overflow-scrolling:touch;">' + html + '</div>';
}

function openCompare() {
 if (selected.length < 2) { grassanError('CMP-003'); return; }
 try {
 buildCompareContent();
 } catch(err) {
 grassanError('CMP-002', err.message);
 document.getElementById('compareContent').innerHTML =
 '<p style="padding:24px 0;color:var(--text-secondary);font-size:14px;">Unable to load comparison. Please try refreshing the page.</p>';
 }
 const overlay = document.getElementById('compareOverlay');
 overlay.classList.add('open');
 document.body.style.overflow = 'hidden';
}

function closeCompare() {
 document.getElementById('compareOverlay').classList.remove('open');
 document.body.style.overflow = '';
}

function overlayClick(e) {
 if (e.target === document.getElementById('compareOverlay')) closeCompare();
}

// ── Grassan Error Reporting ───────────────────────────────────────────────────
// Call grassanError(code, context) anywhere a button fails.
// Displays a friendly toast with the error code and support link.
// Error codes:
// CMP-001 Compare: system key not found on card
// CMP-002 Compare: failed to build comparison content
// CMP-003 Compare: not enough systems selected (shouldn't surface to user)
// EST-001 Estimator: SYSTEMS data not loaded yet
// EST-002 Estimator: estimateCustomGame threw unexpectedly
// PARTS-001 Parts drawer: system key not found
// PARTS-002 Parts drawer: parts data not available for this system
// CART-001 Cart: add to cart request failed
// CART-002 Cart: fetch cart failed

(function() {
 // Inject toast CSS once
 var style = document.createElement('style');
 style.textContent = [
 '.grassan-err-toast{',
 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(12px);',
 'background:#1a1a1a;border:1px solid #333;border-left:3px solid #ff453a;',
 'border-radius:10px;padding:14px 18px;max-width:420px;width:calc(100vw - 48px);',
 'box-shadow:0 8px 32px rgba(0,0,0,0.4);z-index:99999;',
 'opacity:0;transition:opacity .2s,transform .2s;pointer-events:none;',
 '}',
 '.grassan-err-toast.visible{opacity:1;transform:translateX(-50%) translateY(0);pointer-events:auto;}',
 '.grassan-err-toast__title{font-size:13px;font-weight:600;color:#ff453a;margin-bottom:4px;}',
 '.grassan-err-toast__body{font-size:13px;color:#ccc;line-height:1.5;}',
 '.grassan-err-toast__code{font-family:monospace;font-size:11px;color:#666;margin-top:6px;}',
 '.grassan-err-toast__link{color:#0a84ff;text-decoration:none;}',
 '.grassan-err-toast__link:hover{text-decoration:underline;}',
 '.grassan-err-toast__close{position:absolute;top:10px;right:12px;background:none;border:none;',
 'color:#666;font-size:16px;cursor:pointer;line-height:1;padding:0;}',
 ].join('');
 document.head.appendChild(style);

 var _toastEl = null;
 var _toastTimer = null;

 var MESSAGES = {
 'CMP-001': "We couldn't identify which system that button belongs to.",
 'CMP-002': "Something went wrong building the comparison.",
 'CMP-003': "Please select at least 2 systems to compare.",
 'CMP-004': "You can compare up to 3 systems at a time. Remove one before adding another.",
 'EST-001': "Performance data hasn't loaded yet. Try again in a moment.",
 'EST-002': "The FPS estimator ran into an unexpected problem.",
 'PARTS-001': "We couldn't identify which system to show parts for.",
 'PARTS-002': "Parts data for this system isn't available yet.",
 'CART-001': "We weren't able to add this to your cart.",
 'CART-002': "We weren't able to load your cart.",
 };

 window.grassanError = function(code, detail) {
 var msg = MESSAGES[code] || 'Something unexpected happened.';
 console.error('[Grassan ' + code + ']', detail || '');

 if (!_toastEl) {
 _toastEl = document.createElement('div');
 _toastEl.className = 'grassan-err-toast';
 _toastEl.innerHTML =
 '<button class="grassan-err-toast__close" onclick="this.closest(\'.grassan-err-toast\').classList.remove(\'visible\')">&times;</button>' +
 '<div class="grassan-err-toast__title">Something went wrong</div>' +
 '<div class="grassan-err-toast__body">' +
 '<span class="grassan-err-toast__msg"></span> ' +
 'If this keeps happening, please let us know at ' +
 '<a class="grassan-err-toast__link" href="mailto:support@grassancomputers.com">support@grassancomputers.com</a>.' +
 '</div>' +
 '<div class="grassan-err-toast__code"></div>';
 document.body.appendChild(_toastEl);
 }

 _toastEl.querySelector('.grassan-err-toast__msg').textContent = msg;
 _toastEl.querySelector('.grassan-err-toast__code').textContent = 'Error code: ' + code;
 _toastEl.classList.add('visible');

 clearTimeout(_toastTimer);
 _toastTimer = setTimeout(function() {
 _toastEl.classList.remove('visible');
 }, 8000);
 };
})();

// ── Shopify Cart
function openCart() {
 fetchCart();
 document.getElementById('cartOverlay').classList.add('open');
 document.body.style.overflow = 'hidden';
}

function closeCart() {
 const overlay = document.getElementById('cartOverlay');
 if (overlay) { overlay.classList.remove('open'); document.body.style.overflow = ''; }
}

function cartOverlayClick(e) {
 if (e.target === document.getElementById('cartOverlay')) closeCart();
}

async function fetchCart() {
 try {
 const res = await fetch('/cart.js');
 const cart = await res.json();
 renderCart(cart);
 } catch(e) { grassanError('CART-002', e.message); }
}

function renderCart(cart) {
 const body = document.getElementById('cartDrawerBody');
 const footer = document.getElementById('cartDrawerFooter');
 const subtitle = document.getElementById('cartItemCount');
 if (!body) return;

 const count = cart.item_count || 0;
 if (subtitle) subtitle.textContent = count + ' item' + (count !== 1 ? 's' : '');

 const badge = document.getElementById('cartCountBadge');
 if (badge) { badge.textContent = count; count > 0 ? badge.classList.add('has-items') : badge.classList.remove('has-items'); }

 if (count === 0) {
 body.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn-filled" onclick="closeCart()">Browse Systems</a></div>';
 if (footer) footer.style.display = 'none';
 return;
 }

 let html = '';
 (cart.items || []).forEach(item => {
 html += `<div class="cart-item"><div class="cart-item-info"><div class="cart-item-name">${item.title}</div><div class="cart-item-price">${formatMoney(item.final_price)} &times; ${item.quantity}</div></div><button class="cart-item-remove" onclick="removeCartItem('${item.key}')">&#215;</button></div>`;
 });
 body.innerHTML = html;
 if (footer) {
 footer.style.display = '';
 const totalEl = document.getElementById('cartSubtotal');
 if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
 }
}

function formatMoney(cents) {
 return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

async function addToCart(variantId, btn) {
 if (!variantId) { openCart(); return; }
 try {
 const res = await fetch('/cart/add.js', {
 method: 'POST',
 headers: {'Content-Type': 'application/json'},
 body: JSON.stringify({id: variantId, quantity: 1})
 });
 if (!res.ok) throw new Error('Add to cart failed');
 await fetchCart();
 openCart();
 if (btn) {
 const orig = btn.dataset.origText || btn.textContent;
 btn.dataset.origText = orig;
 btn.textContent = 'Added ✓';
 btn.disabled = false;
 setTimeout(() => { btn.textContent = orig; }, 2000);
 }
 } catch(e) {
 grassanError('CART-001', e.message);
 if (btn) { btn.textContent = btn.dataset.origText || 'Get Started →'; btn.disabled = false; }
 openCart();
 }
}

async function removeCartItem(key) {
 try {
 await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id: key, quantity: 0}) });
 fetchCart();
 } catch(e) {}
}

function getStarted(btn) {
 const card = btn ? btn.closest('.product-card') : null;
 if (!card) { window.location.href = '/collections/all'; return; }
 const handle = card.dataset.handle;
 window.location.href = handle ? '/products/' + handle : '/collections/all';
}

if (document.readyState === 'complete') {
 setTimeout(fetchCart, 500);
} else {
 window.addEventListener('load', function() { setTimeout(fetchCart, 200); });
}

// ── Search bar toggle
function toggleSearch() {
 const overlay = document.getElementById('searchOverlay');
 if (!overlay) return;
 const isOpen = overlay.classList.contains('open');
 if (isOpen) {
 closeSearch();
 } else {
 overlay.classList.add('open');
 document.body.style.overflow = 'hidden';
 setTimeout(() => { const inp = document.getElementById('searchInput'); if (inp) inp.focus(); }, 150);
 }
}

function closeSearch() {
 const overlay = document.getElementById('searchOverlay');
 if (overlay) overlay.classList.remove('open');
 document.body.style.overflow = '';
}

document.addEventListener('keydown', function(e) {
 if (e.key === 'Escape') { closeSearch(); closeCompare(); closeParts(); closeCart(); if (_fpsTooltipOpen) { _fpsTooltipOpen = false; _fpsTooltipAnchor = null; getFpsTooltip().classList.remove('visible'); } }
 if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); toggleSearch(); }
});

// ── FPS tooltip
var _fpsTooltipOpen = false;
var _fpsTooltipAnchor = null;
var _fpsTooltipEl = null;

function getFpsTooltip() {
 if (_fpsTooltipEl) return _fpsTooltipEl;
 var box = document.createElement('div');
 box.id = 'fpsTooltipBox';
 box.className = 'fps-tooltip-box';
 box.setAttribute('role', 'tooltip');
 box.innerHTML = '<strong>How to read these bars</strong>' +
 'Each bar shows estimated average FPS with upscaling &amp; frame generation active. ' +
 'The short grey bar is a console (PS5 / Xbox Series X) at its locked frame rate — typically 60 fps. ' +
 'The coloured bar is this PC. Longer bar = smoother gameplay. Numbers show the estimated range.';
 document.body.appendChild(box);
 _fpsTooltipEl = box;
 return box;
}

function positionTooltip(btn, box) {
 var rect = btn.getBoundingClientRect();
 var scrollY = window.scrollY || window.pageYOffset;
 var scrollX = window.scrollX || window.pageXOffset;
 box.style.position = 'absolute';
 box.style.top = (rect.bottom + scrollY + 10) + 'px';
 box.style.left = (rect.left + scrollX) + 'px';
 box.style.zIndex = '9999';
 requestAnimationFrame(function() {
 var boxRect = box.getBoundingClientRect();
 if (boxRect.right > window.innerWidth - 12) {
 box.style.left = Math.max(8, window.innerWidth - boxRect.width - 12 + scrollX) + 'px';
 }
 });
}

function toggleFpsTooltip(e) {
 e.stopPropagation();
 var btn = e.currentTarget;
 var box = getFpsTooltip();
 if (_fpsTooltipOpen && _fpsTooltipAnchor === btn) {
 _fpsTooltipOpen = false;
 _fpsTooltipAnchor = null;
 box.classList.remove('visible');
 return;
 }
 _fpsTooltipOpen = true;
 _fpsTooltipAnchor = btn;
 positionTooltip(btn, box);
 box.classList.add('visible');
}

document.addEventListener('click', function(e) {
 if (!_fpsTooltipOpen) return;
 var box = getFpsTooltip();
 if (!box.contains(e.target) && !e.target.classList.contains('fps-tooltip-btn')) {
 _fpsTooltipOpen = false;
 _fpsTooltipAnchor = null;
 box.classList.remove('visible');
 }
});

window.addEventListener('scroll', function() {
 if (_fpsTooltipOpen && _fpsTooltipAnchor) positionTooltip(_fpsTooltipAnchor, getFpsTooltip());
}, { passive: true });

setTimeout(function() { document.dispatchEvent(new CustomEvent('grassan:ready')); }, 0);

// ── FPS Bar Rotation ─────────────────────────────────────────────────────────
// Periodically cycles fps bars through different games on both front page cards
// and product page bars, with a fade transition.

var FPS_ROTATION_POOL = [
 // ── Esports / CPU-limited ────────────────────────────────────────────
 { name: 'Valorant', demand: 0.995 },
 { name: 'Balatro', demand: 0.990 },
 { name: 'Stardew Valley', demand: 0.980 },
 { name: 'Brotato', demand: 0.990 },
 { name: 'Among Us', demand: 0.990 },
 { name: 'Terraria', demand: 0.980 },
 { name: 'Vampire Survivors', demand: 0.980 },
 { name: 'CS:GO', demand: 0.970, pcOnly: true },
 { name: 'Rocket League', demand: 0.970 },
 { name: 'League of Legends', demand: 0.970, pcOnly: true },
 { name: 'Enter the Gungeon', demand: 0.970 },
 { name: 'Spelunky 2', demand: 0.970 },
 { name: 'Old School RS', demand: 0.970, pcOnly: true },
 { name: 'Cuphead', demand: 0.960 },
 { name: 'Dead Cells', demand: 0.960 },
 { name: 'Portal 2', demand: 0.960 },
 { name: 'Ori: Blind Forest', demand: 0.960 },
 { name: 'RimWorld', demand: 0.960, pcOnly: true },
 { name: "Don't Starve", demand: 0.960 },
 { name: 'Blasphemous 2', demand: 0.950 },
 { name: 'Rogue Legacy 2', demand: 0.950 },
 { name: 'Hollow Knight', demand: 0.950 },
 { name: 'Overcooked! 2', demand: 0.950 },
 { name: 'Ori: Will of Wisps', demand: 0.940 },
 { name: 'Disco Elysium', demand: 0.940, pcOnly: true },
 { name: 'Golf w/ Friends', demand: 0.940 },
 { name: 'Content Warning', demand: 0.940 },
 { name: 'Alien: Isolation', demand: 0.930 },
 { name: 'StarCraft II', demand: 0.930, pcOnly: true },
 { name: 'AoE II: DE', demand: 0.930, pcOnly: true },
 { name: 'Pummel Party', demand: 0.930 },
 { name: 'Paladins', demand: 0.920 },
 { name: 'BattleBit', demand: 0.920, pcOnly: true },
 { name: 'Persona 5 Royal', demand: 0.920 },
 { name: 'Factorio', demand: 0.920, pcOnly: true },
 { name: 'Tunic', demand: 0.920 },
 { name: 'Neon White', demand: 0.920 },
 { name: 'Lethal Company', demand: 0.920 },
 { name: 'Hades II', demand: 0.900 },
 { name: 'Pillars of Eternity', demand: 0.900 },
 { name: 'Wasteland 3', demand: 0.900, pcOnly: true },
 { name: 'Little Nightmares 2', demand: 0.900 },
 { name: 'Parkitect', demand: 0.900 },
 { name: 'Overwatch 2', demand: 0.890 },
 { name: 'CS2', demand: 0.910, pcOnly: true },
 { name: 'Albion Online', demand: 0.880, pcOnly: true },
 { name: 'Outer Wilds', demand: 0.880 },
 { name: 'Dark Souls Remaster', demand: 0.880 },
 { name: 'Edith Finch',demand: 0.880 },
 { name: 'Splitgate 2', demand: 0.880, pcOnly: true },
 { name: 'DOOM: Dark Ages', demand: 0.880 },
 { name: 'Rainbow Six Siege', demand: 0.880 },
 { name: 'Apex Legends', demand: 0.880 },
 { name: 'Halo Infinite', demand: 0.880 },
 { name: 'Metaphor: RF', demand: 0.880 },
 { name: 'Ni No Kuni II', demand: 0.880 },
 { name: 'DOOM Eternal', demand: 0.910 },
 { name: 'Fortnite', demand: 0.860 },
 { name: 'It Takes Two', demand: 0.860 },
 { name: 'A Way Out', demand: 0.860 },
 { name: 'Sifu', demand: 0.860 },
 { name: 'Dragon Quest XI', demand: 0.860 },
 { name: 'Amnesia: Rebirth', demand: 0.860 },
 { name: 'Pathfinder: Wrath', demand: 0.860, pcOnly: true },
 { name: 'Stellaris', demand: 0.850, pcOnly: true },
 { name: 'Victoria 3', demand: 0.840, pcOnly: true },
 { name: 'Detroit: BH', demand: 0.900 },
 { name: 'Forza Horizon 5', demand: 0.840 },
 { name: 'Two Point Campus', demand: 0.840 },
 { name: 'The Forest', demand: 0.840 },
 { name: 'Fall Guys', demand: 0.840 },
 { name: 'Dead by Daylight', demand: 0.880 },
 { name: 'Ghostrunner', demand: 0.880 },
 { name: 'Grounded', demand: 0.820 },
 { name: 'Lost Ark', demand: 0.820, pcOnly: true },
 { name: 'Age of Empires IV', demand: 0.880, pcOnly: true },
 { name: 'Sekiro', demand: 0.880 },
 { name: 'Dark Souls III', demand: 0.880 },
 { name: 'Nioh 2', demand: 0.880 },
 { name: 'Dyson Sphere Prog.', demand: 0.820 },
 { name: 'NieR Replicant', demand: 0.880 },
 { name: 'Astroneer', demand: 0.820 },
 { name: 'Divinity: OS2', demand: 0.820 },
 { name: 'Shadow of Mordor', demand: 0.820 },
 { name: 'Poppy Playtime', demand: 0.800 },
 { name: 'Split Fiction', demand: 0.780 },
 { name: 'Forza Motorsport', demand: 0.780 },
 { name: 'Ratchet & Clank',demand: 0.780 },
 // ── Light-mid ────────────────────────────────────────────────────────
 { name: 'NieR: Automata', demand: 0.760 },
 { name: 'Ghostrunner 2', demand: 0.760 },
 { name: 'Death Stranding', demand: 0.760 },
 { name: 'Subnautica', demand: 0.760 },
 { name: 'Guild Wars 2', demand: 0.760 },
 { name: 'Farming Sim 25', demand: 0.760 },
 { name: 'Dirt Rally 2.0', demand: 0.760 },
 { name: 'WRC Generations', demand: 0.760 },
 { name: 'Cities: Skylines', demand: 0.760 },
 { name: 'Deep Rock Galactic', demand: 0.870 },
 { name: 'Miles Morales', demand: 0.850 },
 { name: 'Euro Truck Sim 2', demand: 0.720 },
 { name: 'American Truck Sim', demand: 0.720 },
 { name: 'Green Hell', demand: 0.720 },
 { name: 'Shadow of War', demand: 0.720 },
 { name: 'Wreckfest', demand: 0.720 },
 { name: 'Outer Worlds', demand: 0.720 },
 { name: 'Half-Life: Alyx', demand: 0.700, pcOnly: true },
 { name: 'Call of Duty', demand: 0.700 },
 { name: 'God of War', demand: 0.700 },
 { name: 'EA Sports FC 25', demand: 0.840 },
 { name: 'The Crew: MF', demand: 0.700 },
 { name: 'Vermintide 2', demand: 0.700 },
 { name: 'Elden Ring', demand: 0.680 },
 { name: 'Witcher 3', demand: 0.680 },
 { name: 'GoW: Ragnarök', demand: 0.680 },
 { name: 'Days Gone', demand: 0.680 },
 { name: 'Anno 1800', demand: 0.680 },
 { name: 'CoH 3', demand: 0.680, pcOnly: true },
 { name: 'Satisfactory', demand: 0.680 },
 { name: 'NBA 2K25', demand: 0.680 },
 { name: 'Insurgency: SS', demand: 0.680 },
 { name: 'JW: Evolution 2', demand: 0.680 },
 { name: 'The Quarry', demand: 0.640 },
 { name: "No Man's Sky", demand: 0.640 },
 { name: "Baldur's Gate 3", demand: 0.650 },
 { name: 'Ghost of Tsushima', demand: 0.650 },
 { name: 'Helldivers 2', demand: 0.650 },
 { name: 'Warzone', demand: 0.650 },
 { name: 'Marvel Rivals', demand: 0.650 },
 { name: 'Deadlock', demand: 0.650 },
 { name: 'Horizon: FW', demand: 0.650 },
 { name: 'Horizon: ZD', demand: 0.650 },
 { name: 'Like a Dragon: IW', demand: 0.650 },
 { name: 'Age of Sigmar', demand: 0.620 },
 { name: 'Sons of Forest', demand: 0.620 },
 { name: 'Manor Lords', demand: 0.620, pcOnly: true },
 { name: 'Planet Zoo', demand: 0.620 },
 { name: 'Bannerlord II', demand: 0.620 },
 { name: 'Red Dead 2', demand: 0.620 },
 // ── Mid demand ───────────────────────────────────────────────────────
 { name: 'Cyberpunk 2077', demand: 0.600 },
 { name: 'Planet Coaster 2', demand: 0.600 },
 { name: 'ARC Raiders', demand: 0.580 },
 { name: 'The Finals', demand: 0.570 },
 { name: 'Ready or Not', demand: 0.580 },
 { name: 'Hunt: Showdown', demand: 0.580 },
 { name: 'Tarkov', demand: 0.580, pcOnly: true },
 { name: 'New World', demand: 0.580, pcOnly: true },
 { name: 'Black Desert', demand: 0.580 },
 { name: 'Talos Principle II', demand: 0.580 },
 { name: 'Phasmophobia', demand: 0.580, pcOnly: true },
 { name: 'Quantum Break', demand: 0.560 },
 { name: 'Avowed', demand: 0.560 },
 { name: 'Indiana Jones',demand: 0.550 },
 { name: 'Ghostwire: Tokyo', demand: 0.520 },
 { name: 'Starfield', demand: 0.520 },
 { name: 'Hogwarts Legacy', demand: 0.500 },
 { name: 'Hell Let Loose', demand: 0.500, pcOnly: true },
 { name: 'Space Marine 2', demand: 0.500 },
 { name: 'Dying Light 2', demand: 0.490 },
 { name: 'Squad', demand: 0.480, pcOnly: true },
 { name: 'Assetto Corsa: ACC', demand: 0.480 },
 { name: 'Assetto Corsa Evo', demand: 0.450 },
 { name: 'Star Wars Jedi', demand: 0.420 },
 { name: 'Control', demand: 0.420 },
 { name: 'Kingdom Come II', demand: 0.420 },
 { name: 'FF VII Rebirth', demand: 0.440 },
 { name: 'Final Fantasy XVI', demand: 0.580 },
 { name: 'Total War: WH3', demand: 0.380 },
 { name: 'Total War: 3 Kgdms', demand: 0.380 },
 // ── Heavy ────────────────────────────────────────────────────────────
 { name: 'Remnant 2', demand: 0.300 },
 { name: "Dragon's Dogma 2", demand: 0.280 },
 { name: 'AC: Shadows', demand: 0.250 },
 { name: 'MH: Wilds', demand: 0.200 },
 { name: 'Oblivion Remastered', demand: 0.180 },
 { name: 'Silent Hill 2', demand: 0.180 },
 { name: 'A Plague Tale II', demand: 0.180 },
 { name: 'Lords of Fallen', demand: 0.120 },
 { name: 'Alan Wake 2', demand: 0.100 },
 { name: 'Black Myth: Wukong', demand: 0.050 },
 { name: 'MSFS 2024', demand: 0.060 },
 { name: 'ARK: SA', demand: 0.020 },
];

function _fpsBracket(demand) {
 if (demand >= 0.85) return 'esports';
 if (demand >= 0.75) return 'light';
 if (demand >= 0.61) return 'cod';
 if (demand >= 0.35) return 'mid';
 return 'heavy';
}

// Calculate fps for a build+demand using the target resolution and max upscaling.
// gameName: optional — if provided, checks FPS_NO_FRAMEGEN and uses SR-only mult if unsupported.
function _calcFpsForBuild(buildKey, demand, resOverride, gameName) {
 var res = resOverride || BUILD_TARGET_RES[buildKey] || '1080p';
 var bucket = NATIVE_FPS[buildKey] ? NATIVE_FPS[buildKey][res] : null;
 if (!bucket) return null;
 var bracket = _fpsBracket(demand);
 var native_fps;
 if (bracket === 'esports') {
 // Interpolate within esports range: 0.85=esports anchor, 1.0=super anchor
 var te = (demand - 0.85) / 0.15;
 native_fps = Math.round(bucket.esports + ((bucket.super || bucket.esports * 1.3) - bucket.esports) * Math.min(te, 1));
 } else if (bracket === 'light') {
 // Interpolate between cod and esports: 0.75=light, 0.85=esports
 var tl = (demand - 0.75) / 0.10;
 native_fps = Math.round(bucket.light + (bucket.esports - bucket.light) * Math.min(tl, 1));
 } else if (bracket === 'cod') {
 // Interpolate between mid and light: 0.61=cod, 0.75=light
 var tc = (demand - 0.61) / 0.14;
 native_fps = Math.round(bucket.cod + (bucket.light - bucket.cod) * Math.min(tc, 1));
 } else if (bracket === 'mid') {
 var t = (demand - 0.35) / 0.25;
 native_fps = Math.round(bucket.heavy + (bucket.mid - bucket.heavy) * t);
 } else {
 var hFloor = Math.min(12, bucket.heavy * 0.30);
 native_fps = Math.round(hFloor + (bucket.heavy - hFloor) * (demand / 0.35));
 }
 // Use max upscaling unless game doesn't support frame generation
 var upscaleKey = UPSCALE_FALLBACK[buildKey] || 'sr';
 var noFg = false;
 if (gameName && FPS_NO_FRAMEGEN) {
 var fgKey = _normalizeGameName(gameName);
 noFg = FPS_NO_FRAMEGEN.has(fgKey) || FPS_NO_FRAMEGEN.has(GAME_NAME_ALIASES[fgKey] || '');
 }
 // srOnly = the displayed FPS reflects upscaling without frame generation.
 // Two ways this happens: the game blocks FG, or the GPU itself has no FG path
 // ('xess' is SR-only on Arc A750 since A750 doesn't expose XeSS Frame Generation).
 var srOnly = noFg || upscaleKey === 'xess' || upscaleKey === 'sr';
 var mult;
 if (noFg) {
 // Game doesn't support FG — use SR-only multiplier
 var srTable = (bracket === 'esports' && UPSCALE_SR_ONLY_ESPORTS[upscaleKey])
 ? UPSCALE_SR_ONLY_ESPORTS[upscaleKey]
 : (UPSCALE_SR_ONLY[upscaleKey] || UPSCALE_SR_ONLY.sr);
 mult = srTable[buildKey] || 1.0;
 } else if (bracket === 'esports' && ESPORTS_MULT[upscaleKey]) {
 mult = ESPORTS_MULT[upscaleKey][buildKey] || 1.0;
 } else {
 mult = (UPSCALE_MULT[upscaleKey] || {})[buildKey] || 1.0;
 }
 var final = Math.round(native_fps * mult);
 // Apply FPS lock if game is in FPS_LOCKED.
 var capInfo = null;
 if (gameName && typeof FPS_LOCKED !== 'undefined') {
 var lockKey = _normalizeGameName(gameName);
 var lockEntry = FPS_LOCKED[lockKey] || FPS_LOCKED[GAME_NAME_ALIASES[lockKey] || ''];
 if (lockEntry && final > lockEntry.cap) {
 capInfo = { cap: lockEntry.cap, type: lockEntry.type, note: lockEntry.note };
 final = lockEntry.cap;
 }
 }
 return {
 mid: final,
 lo: Math.round(final * 0.9),
 hi: Math.round(final * 1.1),
 cap: capInfo,
 srOnly: srOnly
 };
}

// Per-container history: maps container element -> array of recently shown game names
var _fpsHistory = new WeakMap();
var FPS_HISTORY_SIZE = 12; // exclude last 12 shown (3 full rounds)

// Pick exactly `count` games that: (a) haven't been shown recently, (b) produce lo >= 60fps.
function _pickRotationGames(count, buildKey, resOverride, container) {
 var history = (container && _fpsHistory.has(container)) ? _fpsHistory.get(container) : [];
 var historySet = {};
 history.forEach(function(n) { historySet[n] = true; });

 // Shuffle, then prefer non-recent games
 var shuffled = FPS_ROTATION_POOL.slice().sort(function() { return Math.random() - 0.5; });
 var fresh = [], stale = [], fallback = [];

 for (var i = 0; i < shuffled.length; i++) {
 var g = shuffled[i];
 var fps = _calcFpsForBuild(buildKey, g.demand, resOverride, g.name);
 if (!fps) continue;
 var entry = { game: g, fps: fps };
 // FPS-locked games are "fresh" if they hit their cap — that's the designed result.
 var hitCap = fps.cap && fps.mid === fps.cap.cap;
 if (historySet[g.name]) {
 stale.push(entry);
 } else if (fps.lo >= 60 || hitCap) {
 fresh.push(entry);
 } else {
 fallback.push(entry);
 }
 }

 // Fill from fresh first, then stale (old but >=60fps), then fallback (sub-60)
 var result = fresh.slice(0, count);
 if (result.length < count) {
 var staleOk = stale.filter(function(x) { return x.fps.lo >= 60; });
 result = result.concat(staleOk.slice(0, count - result.length));
 }
 if (result.length < count) {
 result = result.concat(fallback.slice(0, count - result.length));
 }
 if (result.length < count) {
 result = result.concat(stale.slice(0, count - result.length));
 }

 // Update history for this container
 if (container) {
 var newHistory = result.map(function(x) { return x.game.name; });
 var combined = newHistory.concat(history);
 _fpsHistory.set(container, combined.slice(0, FPS_HISTORY_SIZE));
 }

 return result;
}

// Map (buildKey, srOnly) to the footnote number shown beneath the card.
// 1 = Upscaling only (no frame gen used in this row)
// 2 = XeSS 2 + XeSS Frame Generation 1× (Arc B580)
// 3 = DLSS 4 + Multi Frame Generation 2× (RTX 50-series)
function _fpsFootnoteFor(buildKey, srOnly) {
 if (srOnly) return 1;
 var k = UPSCALE_FALLBACK[buildKey] || 'sr';
 if (k === 'xessfg') return 2;
 if (k === 'dlss4mfg') return 3;
 return 1;
}

var _FPS_FOOTNOTE_GLYPHS = { 1: '\u00B9', 2: '\u00B2', 3: '\u00B3' };

// Build a single fps-row HTML with fps label on its own line below numbers
function _buildFpsRowHtml(game, buildKey, color, resOverride) {
 var fps = _calcFpsForBuild(buildKey, game.demand, resOverride, game.name);
 if (!fps) return '';
 var MAX_FPS = 530; // max possible (RTX 5090 esports)
 // When a game is FPS-capped (60fps lock, 30fps lock), both PC and console
 // hit the same ceiling, so render both bars at the cap value (not at
 // hi = cap * 1.1, which would make the PC bar appear slightly longer than
 // the console bar even though the displayed FPS is identical).
 var hitCap = fps.cap && fps.mid === fps.cap.cap;
 var pcBarRefFps = hitCap ? fps.cap.cap : fps.hi;
 var barW = Math.round((pcBarRefFps / MAX_FPS) * 95);
 barW = Math.min(Math.max(barW, 3), 95);
 // Console bar width on the same scale as the PC bar.
 // Default reference = 60fps. For capped games, console hits the cap too,
 // so use the cap value to make both bars exactly equal length.
 var consoleRefFps = hitCap ? fps.cap.cap : 60;
 var consoleW = Math.round((consoleRefFps / MAX_FPS) * 95);
 consoleW = Math.min(Math.max(consoleW, 3), 95);
 // For FPS-capped games, show the cap number prominently with a small lock icon.
 // The icon + tooltip works on narrow mobile columns where text labels wouldn't fit.
 var fpsText;
 if (hitCap) {
 var tooltip = (fps.cap.note || ('This game is locked at ' + fps.cap.cap + ' FPS by design.'))
 .replace(/"/g, '&quot;');
 fpsText = '<span class="fps-capped" title="' + tooltip + '">' +
 '<svg class="fps-cap-icon" viewBox="0 0 12 14" aria-hidden="true">' +
 '<path d="M3 6V4a3 3 0 016 0v2" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
 '<rect x="2" y="6" width="8" height="7" rx="1.2" fill="currentColor"/>' +
 '</svg>' +
 fps.cap.cap + '<br>fps' +
 '</span>';
 } else {
 fpsText = fps.lo + '\u2013' + fps.hi + '<br>fps';
 }

 // For PC-only games, replace the solid grey console bar with a faded dashed track.
 // The visual difference + tooltip signals "no console comparison" without crowding the row.
 var consoleRow;
 if (game.pcOnly) {
 consoleRow = '<div class="fps-track-row"><div class="fps-track fps-track-pc-only" ' +
 'title="This game is not available on PlayStation or Xbox. PC only."></div></div>';
 } else {
 consoleRow = '<div class="fps-track-row"><div class="fps-track">' +
 '<div class="bar-console" style="width:' + consoleW + '%"></div>' +
 '</div></div>';
 }

 // Append the footnote superscript so the row references the correct
 // upscaling explanation in the footnote block beneath the card grid.
 var footnoteN = _fpsFootnoteFor(buildKey, fps.srOnly);
 var footnoteSup = '<sup class="fps-footnote-ref">' + (_FPS_FOOTNOTE_GLYPHS[footnoteN] || '') + '</sup>';

 return '<div class="fps-row">' +
 '<span class="fps-game">' + game.name + footnoteSup + '</span>' +
 '<div class="fps-bars">' +
 '<div class="fps-track-row"><div class="fps-track">' +
 '<div class="bar-pc bar-' + color + '" data-w="' + barW + '" style="width:0%"></div>' +
 '</div></div>' +
 consoleRow +
 '</div>' +
 '<span class="fps-num">' + fpsText + '</span>' +
 '</div>';
}

var FPS_BAR_COLORS = {
 core: 'blue', corex: 'green', pro: 'blue', prox: 'blue',
 ultra: 'green', ultrax: 'blue', max: 'white'
};

// Anchor games shown on page-load before rotation begins.
// Core uses Fortnite/CoD/God of War/Elden Ring (mix of esports and AAA at 1080p).
// All other builds use the classic Fortnite/CoD/ARC Raiders/Cyberpunk spread.
var FPS_INITIAL_GAMES = {
 core: [
 { name: 'Fortnite', demand: 0.86 },
 { name: 'CoD', demand: 0.70 },
 { name: 'God of War', demand: 0.70 },
 { name: 'Elden Ring', demand: 0.68 },
 ],
 corex: [
 { name: 'Fortnite', demand: 0.86 },
 { name: 'CoD', demand: 0.70 },
 { name: 'ARC Raiders', demand: 0.58 },
 { name: 'Cyberpunk 2077',demand: 0.60 },
 ],
 pro: [
 { name: 'Fortnite', demand: 0.86 },
 { name: 'CoD', demand: 0.70 },
 { name: 'ARC Raiders', demand: 0.58 },
 { name: 'Cyberpunk 2077',demand: 0.60 },
 ],
 prox: [
 { name: 'Fortnite', demand: 0.86 },
 { name: 'CoD', demand: 0.70 },
 { name: 'ARC Raiders', demand: 0.58 },
 { name: 'Cyberpunk 2077',demand: 0.60 },
 ],
 ultra: [
 { name: 'Fortnite', demand: 0.86 },
 { name: 'CoD', demand: 0.70 },
 { name: 'ARC Raiders', demand: 0.58 },
 { name: 'Cyberpunk 2077',demand: 0.60 },
 ],
 ultrax: [
 { name: 'Fortnite', demand: 0.86 },
 { name: 'CoD', demand: 0.70 },
 { name: 'ARC Raiders', demand: 0.58 },
 { name: 'Cyberpunk 2077',demand: 0.60 },
 ],
 max: [
 { name: 'Fortnite', demand: 0.86 },
 { name: 'CoD', demand: 0.70 },
 { name: 'ARC Raiders', demand: 0.58 },
 { name: 'Cyberpunk 2077',demand: 0.60 },
 ],
};

var FPS_FADE_MS = 700;

// Rotate a single fps-rows container
function _rotateFpsSection(container, buildKey, resOverride) {
 var color = FPS_BAR_COLORS[buildKey] || 'blue';
 var withFps = _pickRotationGames(4, buildKey, resOverride, container);
 withFps.sort(function(a, b) { return b.fps.mid - a.fps.mid; });

 var html = withFps.map(function(x) {
 return _buildFpsRowHtml(x.game, buildKey, color, resOverride);
 }).join('');

 // Lock height before swap
 var currentH = container.offsetHeight;
 container.style.minHeight = currentH + 'px';

 // Fade out existing rows individually, staggered top→bottom
 var oldRows = container.querySelectorAll('.fps-row');
 oldRows.forEach(function(row, i) {
 row.style.transition = 'opacity ' + (FPS_FADE_MS / 1000) + 's ease ' + (i * 60) + 'ms';
 row.style.opacity = '0';
 });

 // After fade-out completes, swap content and fade new rows in staggered
 setTimeout(function() {
 container.innerHTML = html;
 var newRows = container.querySelectorAll('.fps-row');

 // Start each row invisible, then stagger fade-in + bar animation
 newRows.forEach(function(row, i) {
 var delay = i * 110; // 110ms between each row
 row.style.opacity = '0';
 row.style.transform = 'translateY(8px)';
 row.style.transition = 'none';

 setTimeout(function() {
 row.style.transition = 'opacity 0.45s ease, transform 0.45s cubic-bezier(0.16, 1, 0.3, 1)';
 row.style.opacity = '1';
 row.style.transform = 'none';

 // Animate the bar inside this row
 var bar = row.querySelector('.bar-pc[data-w]');
 if (bar) {
 bar.style.transition = 'none';
 bar.style.width = '0%';
 requestAnimationFrame(function() {
 requestAnimationFrame(function() {
 bar.style.transition = 'width 1.2s cubic-bezier(0.16, 1, 0.3, 1)';
 bar.style.width = (bar.dataset.w || 0) + '%';
 });
 });
 }
 }, delay);
 });
 }, FPS_FADE_MS);
}

// Render initial fps bars from live NATIVE_FPS calc — same math as rotation.
function _renderInitialBars(container, buildKey, resOverride) {
 var color = FPS_BAR_COLORS[buildKey] || 'blue';
 var games = FPS_INITIAL_GAMES[buildKey] || FPS_INITIAL_GAMES.pro;

 // Compute fps for each initial game; they're pre-vetted to be >=60fps for non-Core builds,
 // but we filter here too for safety and sort high-to-low.
 var withFps = games.map(function(g) {
 var fps = _calcFpsForBuild(buildKey, g.demand, resOverride, g.name);
 return { game: g, fps: fps };
 }).filter(function(x) { return x.fps !== null; });

 withFps.sort(function(a, b) { return b.fps.mid - a.fps.mid; });

 var html = withFps.map(function(x) {
 return _buildFpsRowHtml(x.game, buildKey, color, resOverride);
 }).join('');

 container.innerHTML = html;

 requestAnimationFrame(function() {
 requestAnimationFrame(function() {
 container.querySelectorAll('.bar-pc[data-w]').forEach(function(b) {
 b.style.transition = 'width 1.1s cubic-bezier(0.16, 1, 0.3, 1)';
 b.style.width = (b.dataset.w || 0) + '%';
 });
 });
 });
}

// Front page: rotate all cards. Max card has two fps-rows (1440p + 4K).
function _startFrontPageRotation() {
 var cards = document.querySelectorAll('.product-card[data-build-key]');
 if (!cards.length) return;

 // Render initial bars immediately on load
 cards.forEach(function(card) {
 var buildKey = card.dataset.buildKey;
 if (!buildKey) return;
 if (buildKey === 'max') {
 var rows = card.querySelectorAll('.fps-rows');
 if (rows[0]) _renderInitialBars(rows[0], 'max', '1440p');
 if (rows[1]) _renderInitialBars(rows[1], 'max', '4k');
 } else {
 var fpsRows = card.querySelector('.fps-rows');
 if (fpsRows) _renderInitialBars(fpsRows, buildKey, null);
 }
 });

 function rotate() {
 cards.forEach(function(card) {
 var buildKey = card.dataset.buildKey;
 if (!buildKey) return;
 if (buildKey === 'max') {
 var rows = card.querySelectorAll('.fps-rows');
 if (rows[0]) _rotateFpsSection(rows[0], 'max', '1440p');
 if (rows[1]) _rotateFpsSection(rows[1], 'max', '4k');
 } else {
 var fpsRows = card.querySelector('.fps-rows');
 if (fpsRows) _rotateFpsSection(fpsRows, buildKey, null);
 }
 });
 }

 setTimeout(function() { rotate(); setInterval(rotate, 8000); }, 5000);
}

// Product page rotation
function _startPdpRotation(buildKey) {
 var fpsRows = document.getElementById('pdpFpsRows');
 if (!fpsRows || !buildKey) return;

 if (buildKey === 'max') {
 // Max product page: pdpFpsRows contains both 1440p and 4K sections.
 // We need to find the two fps-row groups by their position relative to
 // the section dividers, then rotate each independently.
 // We do this by querying all .fps-row elements and splitting them at the 4K divider.
 // Easier: wrap each group in a sub-container on first rotation, then target those.
 //
 // Approach: on first rotation, replace the flat layout with two named sub-containers,
 // then rotate each sub-container independently going forward.

 var _maxInit = false;

 function rotateMax() {
 if (!_maxInit) {
 // Find all current fps-rows (flat structure from initPdpFps)
 // and the 4K divider between them. Rebuild with two sub-containers.
 var children = Array.prototype.slice.call(fpsRows.childNodes);
 var before4k = [], after4k = [], found4k = false, divider4k = null;
 children.forEach(function(node) {
 var text = node.textContent || '';
 if (!found4k && text.trim() === '4K') {
 found4k = true;
 divider4k = node.cloneNode(true);
 } else if (!found4k) {
 before4k.push(node.cloneNode(true));
 } else {
 after4k.push(node.cloneNode(true));
 }
 });

 // Rebuild with explicit sub-containers
 var sub1440 = document.createElement('div');
 sub1440.id = 'pdpFpsRows1440';
 before4k.forEach(function(n) { sub1440.appendChild(n); });

 var sub4k = document.createElement('div');
 sub4k.id = 'pdpFpsRows4k';
 after4k.forEach(function(n) { sub4k.appendChild(n); });

 fpsRows.innerHTML = '';
 fpsRows.appendChild(sub1440);
 if (divider4k) fpsRows.appendChild(divider4k);
 fpsRows.appendChild(sub4k);

 _maxInit = true;
 }

 var s1440 = document.getElementById('pdpFpsRows1440');
 var s4k = document.getElementById('pdpFpsRows4k');
 if (s1440) _rotateFpsSection(s1440, 'max', '1440p');
 if (s4k) _rotateFpsSection(s4k, 'max', '4k');
 }

 setTimeout(function() { rotateMax(); setInterval(rotateMax, 8000); }, 5000);

 } else {
 function rotate() { _rotateFpsSection(fpsRows, buildKey, null); }
 setTimeout(function() { rotate(); setInterval(rotate, 8000); }, 5000);
 }
}

// Hook into grassan:ready
document.addEventListener('grassan:ready', function() {
 _startFrontPageRotation();
}, { once: true });

// ── PDP scroll-triggered reveal for below-fold sections ──────────────────
(function() {
 var pdpScrollEls = document.querySelectorAll('.pdp-estimator-section.pdp-reveal');
 if (!pdpScrollEls.length) return;
 if ('IntersectionObserver' in window) {
 var obs = new IntersectionObserver(function(entries) {
 entries.forEach(function(e) {
 if (e.isIntersecting) {
 e.target.classList.add('pdp-revealed');
 obs.unobserve(e.target);
 }
 });
 }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
 pdpScrollEls.forEach(function(el) { obs.observe(el); });
 } else {
 pdpScrollEls.forEach(function(el) { el.classList.add('pdp-revealed'); });
 }
})();

function cmClearGenre() {
 var sel = document.getElementById('cmGamePreset');
 if (sel) sel.value = '';
}
function cmClearInput() {
 var inp = document.getElementById('cmGameInput');
 if (inp) inp.value = '';
}

// ── Upscaling multipliers
// Based on real benchmarks: DLSS 4 MFG 2x delivers 2.0–2.4x native at 1080p/1440p depending on game.
// XeSS 2 Frame Gen on Arc B580: ~1.7–1.9x in supported titles.
// XeSS SR on Arc: ~1.30–1.40x depending on title support.
const UPSCALE_MULT = {
 native: { core:1.0, corex:1.0, pro:1.0, prox:1.0, ultra:1.0, ultrax:1.0, max:1.0 },
 sr: { core:1.35, corex:1.35, pro:1.40, prox:1.45, ultra:1.45, ultrax:1.45, max:1.45 },
 xess: { core:1.35, corex:1.40, pro:1.0, prox:1.0, ultra:1.0, ultrax:1.0, max:1.0 },
 xessfg: { core:1.0, corex:1.80, pro:1.0, prox:1.0, ultra:1.0, ultrax:1.0, max:1.0 },
 dlss4mfg: { core:1.0, corex:1.0, pro:2.20, prox:2.20, ultra:2.20, ultrax:2.30, max:2.40 },
};

const UPSCALE_COMPAT = {
 core: ['native', 'sr', 'xess'],
 corex: ['native', 'sr', 'xess', 'xessfg'],
 pro: ['native', 'sr', 'dlss4mfg'],
 prox: ['native', 'sr', 'dlss4mfg'],
 ultra: ['native', 'sr', 'dlss4mfg'],
 ultrax: ['native', 'sr', 'dlss4mfg'],
 max: ['native', 'sr', 'dlss4mfg'],
};

const UPSCALE_COMPAT_NOTES = {
 core: {
 xessfg: 'Arc A750 supports XeSS SR but not XeSS 2 Frame Gen — showing XeSS SR estimate.',
 dlss4mfg: 'Arc A750 does not support DLSS — showing XeSS SR estimate.',
 },
 corex: {
 dlss4mfg: 'Arc B580 does not support DLSS 4 — showing XeSS 2 Frame Gen estimate.',
 },
 pro: {
 xess: 'RTX 5060 supports XeSS but DLSS 4 is superior — showing DLSS 4 SR estimate.',
 },
 prox: {
 xess: 'RTX 5060 Ti supports XeSS but DLSS 4 is superior — showing DLSS 4 SR estimate.',
 },
 ultra: {
 xess: 'RTX 5070 supports XeSS but DLSS 4 is superior — showing DLSS 4 SR estimate.',
 },
 ultrax: {
 xess: 'RTX 5070 Ti supports XeSS but DLSS 4 is superior — showing DLSS 4 SR estimate.',
 },
 max: {
 xess: 'RTX 5090 supports XeSS but DLSS 4 is superior — showing DLSS 4 MFG estimate.',
 },
};

const UPSCALE_FALLBACK = {
 core: 'xess',
 corex: 'xessfg',
 pro: 'dlss4mfg',
 prox: 'dlss4mfg',
 ultra: 'dlss4mfg',
 ultrax: 'dlss4mfg',
 max: 'dlss4mfg',
};

// ── Game name normalization ──────────────────────────────────────────────────
// Maps display names (with punctuation/abbreviations) to their canonical
// lookup form used by FPS_NO_FRAMEGEN, FPS_LOCKED, and KNOWN_GAMES.
function _normalizeGameName(name) {
 return String(name||'').toLowerCase()
 .replace(/[^a-z0-9 ]/g, ' ')
 .replace(/\s+/g, ' ')
 .trim();
}

// Alias map for short forms used in the rotation pool / quick search.
// Keys are normalized form, values are canonical FPS_NO_FRAMEGEN/FPS_LOCKED keys.
const GAME_NAME_ALIASES = {
 'cs go': 'csgo',
 'old school rs': 'old school runescape',
 'osrs': 'old school runescape',
 'starcraft ii': 'starcraft 2',
 'aoe ii de': 'age of empires 2 de',
 'aoe iv': 'age of empires iv',
 'civ vi': 'civilization vi',
 'metaphor rf': 'metaphor refantazio',
 'dark souls iii': 'dark souls 3',
 'dark souls': 'dark souls 3',
 'ds3': 'dark souls 3',
 'ds 3': 'dark souls 3',
 'rdr': 'red dead redemption 2',
 'witcher 3': 'witcher',
 'witcher iii': 'witcher',
 'tw3': 'witcher',
 'cp': 'cyberpunk 2077',
 'cp 2077': 'cyberpunk 2077',
 'cyberpunk': 'cyberpunk 2077',
 'fh5': 'forza horizon 5',
 'forza': 'forza horizon 5',
 'forza 5': 'forza horizon 5',
 'fc 25': 'ea sports fc 25',
 'fc25': 'ea sports fc 25',
 'fifa 25': 'ea sports fc 25',
 'pubg battlegrounds': 'pubg',
 'spider man': 'spiderman',
 'spiderman miles morales': 'spider-man miles morales',
 'spider man miles morales': 'spider-man miles morales',
 'miles morales': 'spider-man miles morales',
 'mw3': 'cod',
 'mw 3': 'cod',
 'modern warfare': 'cod',
 'modern warfare 3': 'cod',
 'black ops': 'cod',
 'black ops 6': 'cod',
 'doom the dark ages': 'doom: the dark ages',
 'doom dark ages': 'doom: the dark ages',
 'eft': 'tarkov',
 'wukong': 'wukong',
 'black myth': 'wukong',
 'elden': 'elden ring',
 'r6': 'rainbow six',
 'r6 siege': 'rainbow six',
 'rainbow six siege': 'rainbow six',
 'siege': 'rainbow six',
 'apex': 'apex legends',
 'detroit bh': 'detroit become human',
 'detroit': 'detroit become human',
 'horizon zd': 'horizon zero dawn',
 'horizon zd': 'horizon zero dawn',
 'horizon fw': 'horizon forbidden west',
 'horizon fw': 'horizon forbidden west',
 'gow ragnar k': 'god of war ragnarok',
 'gow ragnarok': 'god of war ragnarok',
 'farming sim 25': 'farming simulator 25',
 'farming sim': 'farming simulator',
 'euro truck sim 2': 'euro truck simulator 2',
 'american truck sim': 'american truck simulator',
 'edith finch': 'what remains of edith finch',
 'dark souls remaster':'dark souls remastered',
 'jw evolution 2': 'jurassic world evolution 2',
 'coh 3': 'company of heroes 3',
 'vermintide 2': 'warhammer vermintide 2',
 'insurgency ss': 'insurgency sandstorm',
 'mh wilds': 'monster hunter wilds',
 'mh world': 'monster hunter world',
 'lords of fallen': 'lords of the fallen',
 'msfs': 'microsoft flight simulator',
 'msfs 2024': 'microsoft flight simulator',
 'lethal': 'lethal company',
 'rdr2': 'red dead redemption 2',
 'red dead 2': 'red dead redemption 2',
 'pillars of eternity':'pillars of eternity 2',
 'divinity os2': 'divinity original sin 2',
 'dirt rally 2 0': 'dirt rally 2',
 'finals': 'the finals',
 'new world': 'new world aeternum',
 'black desert': 'black desert online',
 'talos principle ii': 'talos principle 2',
 'assetto corsa acc': 'assetto corsa competizione',
 'acc': 'assetto corsa competizione',
 'total war wh3': 'total war warhammer 3',
 'total war 3 kgdms': 'total war three kingdoms',
 'ark sa': 'ark survival ascended',
 'battlebit': 'battlebit remastered',
 'dyson sphere prog': 'dyson sphere program',
 'mh world': 'monster hunter world',
 'doom dark ages': 'doom: the dark ages',
 'plague tale ii': 'plague tale requiem',
 'dragon s dogma 2': "dragons dogma 2",
 'ac shadows': "assassins creed shadows",
 'cod': 'call of duty',
 'call of duty': 'call of duty',
 'cod warzone': 'warzone',
 'warzone': 'warzone',
};

// Games that do not support frame generation natively.
// For these, the FG multiplier is replaced with SR-only multiplier in fps calc.
// Sources: NVIDIA DLSS official list, AMD FSR list, PCGamingWiki, vendor patch notes.
const FPS_NO_FRAMEGEN = new Set([
 // ── 2D / pixel art / very light ────────────────────────────────────
 'balatro','stardew valley','terraria','celeste','hollow knight',
 'dead cells','rogue legacy 2','blasphemous 2','cuphead',
 'ori and the blind forest','ori and the will of the wisps','ori',
 'ori blind forest','ori will of wisps',
 'inside','slay the spire','binding of isaac','brotato',
 'enter the gungeon','spelunky 2','vampire survivors','among us',
 "don't starve together","don't starve",'core keeper','rimworld','factorio',

 // ── Old engines / pre-DLSS3 era — never received FG ─────────────────
 'portal 2','left 4 dead 2','alien isolation','half life alyx',
 'titanfall 2','titanfall','team fortress 2',
 'rocket league','minecraft',

 // ── Online competitive shooters (no FG due to anti-cheat / latency) ─
 'cs2','csgo','counter-strike','counter strike',
 'apex legends','apex',
 'rainbow six','rainbow six siege','siege','r6',
 'overwatch','overwatch 2',
 'paladins','splitgate 2','battlebit remastered',
 'valorant', // NEW: Valorant has zero upscaling/FG support

 // ── Multiplayer / live-service / persistent worlds (mostly no FG) ───
 'old school runescape','runescape','albion online',
 'dota 2','league of legends','lol',
 'genshin impact','genshin','wuthering waves',
 'world of warcraft','wow','final fantasy xiv',
 'guild wars 2','lost ark','elder scrolls online',
 'new world aeternum','black desert online',
 'helldivers 2','helldivers', // No official FG
 'palworld','rust','enshrouded','valheim','project zomboid',
 'sea of thieves',

 // ── 4X / strategy / sim games — typically CPU-bound, no FG ──────────
 'stellaris','victoria 3','crusader kings','civilization vi',
 'civilization','hearts of iron',
 'total war three kingdoms','disco elysium',
 'divinity original sin 2','divinity 2','divinity',
 'wasteland 3','pillars of eternity 2','pathfinder wrath',
 'starcraft 2','age of empires 2 de','age of empires iv',
 'company of heroes 3','company of heroes',
 'manor lords','bannerlord','planet zoo','planet coaster 2',
 'jurassic world evolution 2','jurassic world','two point campus',
 'dyson sphere program','astroneer','factorio',

 // ── JRPGs / RPGs without FG (Atlus, older Bandai Namco, etc) ────────
 'persona 5 royal','metaphor refantazio','metaphor',
 'dragon quest xi','ni no kuni 2','ni no kuni',
 'yakuza like a dragon','like a dragon infinite wealth',
 'yakuza','like a dragon',
 'nier replicant','nier automata',
 'tekken 8','street fighter 6',

 // ── FromSoftware / souls-likes (no FG support) ──────────────────────
 'elden ring','dark souls 3','dark souls remastered',
 'sekiro','nioh 2',
 // NOTE: Lies of P, Lords of the Fallen, Wukong have FG; do NOT list.

 // ── Sony first-party PC ports — most do NOT have FG ─────────────────
 // Spider-Man games and Ratchet & Clank DO have DLSS 3 / FG.
 'horizon zero dawn','horizon forbidden west','horizon',
 'days gone','god of war','gow','god of war ragnarok',
 'detroit become human','detroit',
 'the last of us',
 'ghost of tsushima',
 // Death Stranding got DLSS 3 in Director's Cut — keep out

 // ── Co-op / party / indie 3D — no FG ────────────────────────────────
 'fall guys','content warning','lethal company',
 'phasmophobia','overcooked 2','pummel party','golf with friends',
 'golf with your friends',
 'parkitect','it takes two','a way out','split fiction',
 'deep rock galactic','warhammer vermintide 2',
 'amnesia rebirth','poppy playtime','little nightmares 2',

 // ── Survival / sandbox 3D without official FG ───────────────────────
 'subnautica','the forest','sons of the forest','green hell',
 "no man's sky",'grounded',

 // ── Misc. older AAA / well-optimised pre-FG titles ──────────────────
 'doom eternal', // NO FG - id Tech 7 doesn't support it
 'doom',
 'tunic','outer wilds','what remains of edith finch','edith finch',
 'neon white','sifu','outer worlds',
 'tales of arise',
 'shadow of mordor','shadow of war',
 'monster hunter world',
 'red dead redemption 2','rdr2', // NO official FG, only DLSS 2 SR
 'the sims 4','sims 4', // No DLSS / FG at all

 // ── Sports / racing without FG (most EA / 2K) ───────────────────────
 'ea sports fc 25','ea sports fc','fifa',
 'nba 2k25','nba 2k',
 'wreckfest','wrc generations',
 'forza motorsport', // NO FG
 // NOTE: Forza Horizon 5 ADDED DLSS 3 / FG in 2023. Do NOT list.
 'farming simulator 25','farming simulator','farming sim',
 'american truck simulator','american truck',
 'euro truck simulator 2','euro truck',
 'the crew motorfest','the crew',
 'dirt rally 2',

 // ── Tactical shooters without FG ────────────────────────────────────
 'ready or not','squad','hell let loose','insurgency sandstorm',
 'insurgency','hunt showdown','tarkov','arc raiders',
 'the finals','finals','battlefield', // BF doesn't have FG yet

 // ── Older Resident Evil / Capcom (RE2/3/Village got FG; older did not)
 // RE Engine games as a whole — Resident Evil 4, Village, MH Wilds DO.
 // Devil May Cry 5: no FG. Capcom older: no FG.
]);

// Games with hard or default soft FPS caps (by design or convention).
// When a game is in this set, the calculator should display the cap with a note,
// or cap the displayed FPS at that value (the FPS lookup will still return
// the raw calculated value; rendering decides whether to show "60 (capped)").
// Sources: PCGamingWiki, vendor patch notes, common community knowledge.
const FPS_LOCKED = {
 // Hard locks (cannot be unlocked without mods)
 'old school runescape': { cap: 50, type: 'hard',
 note: 'Old School RuneScape runs at a fixed 50 FPS by design.', pcOnly:true },
 'runescape': { cap: 50, type: 'hard',
 note: 'RuneScape runs at a fixed 50 FPS by design.', pcOnly:true },

 // 60 FPS hard locks (FromSoftware classics)
 'dark souls remastered': { cap: 60, type: 'hard',
 note: 'Dark Souls Remastered is locked at 60 FPS. Frame Gen has no effect.' },
 'dark souls 3': { cap: 60, type: 'hard',
 note: 'Dark Souls III is locked at 60 FPS. Frame Gen has no effect.' },
 'sekiro': { cap: 60, type: 'hard',
 note: 'Sekiro is locked at 60 FPS. Frame Gen has no effect.' },

 // 60 FPS soft locks (unlockable with mods, but capped by default)
 'elden ring': { cap: 60, type: 'soft',
 note: 'Elden Ring is capped at 60 FPS by default.' },
 'nioh 2': { cap: 120, type: 'soft',
 note: 'Nioh 2 caps at 120 FPS.' },

 // FPS-locked first-party / older console ports
 'horizon zero dawn': { cap: 240, type: 'soft',
 note: 'Horizon Zero Dawn caps at 240 FPS.' },

 // VR / unique cases
 'half life alyx': { cap: 144, type: 'hard',
 note: 'VR titles are capped to display refresh rate.', pcOnly:true },

 // Online MMOs that cap FPS server-tick-style
 'final fantasy xiv': { cap: 60, type: 'soft',
 note: 'FFXIV caps at 60 FPS by default (can be raised in config).' },
 'world of warcraft': { cap: 200, type: 'soft',
 note: 'WoW soft-caps based on display settings.' },

 // 60 FPS by design (older era / engine limitations)
 'left 4 dead 2': { cap: 300, type: 'soft',
 note: 'Source engine soft-caps around 300 FPS.' },
 'portal 2': { cap: 300, type: 'soft',
 note: 'Source engine soft-caps around 300 FPS.' },
 'alien isolation': { cap: 144, type: 'soft',
 note: 'Alien Isolation engine soft-caps near display refresh.' },
};

const UPSCALE_SR_ONLY = {
 native: { core:1.0, corex:1.0, pro:1.0, prox:1.0, ultra:1.0, ultrax:1.0, max:1.0 },
 xess: { core:1.35, corex:1.40, pro:1.35, prox:1.35, ultra:1.35, ultrax:1.35, max:1.35 },
 xessfg: { core:1.35, corex:1.40, pro:1.40, prox:1.40, ultra:1.40, ultrax:1.40, max:1.40 },
 dlss4mfg: { core:1.35, corex:1.40, pro:1.40, prox:1.45, ultra:1.45, ultrax:1.45, max:1.45 },
 sr: { core:1.35, corex:1.40, pro:1.40, prox:1.45, ultra:1.45, ultrax:1.45, max:1.45 },
};
const UPSCALE_SR_ONLY_ESPORTS = {
 xess: { core:1.25, corex:1.25, pro:1.25, prox:1.25, ultra:1.25, ultrax:1.25, max:1.25 },
 xessfg: { core:1.25, corex:1.25, pro:1.25, prox:1.25, ultra:1.25, ultrax:1.25, max:1.25 },
 dlss4mfg: { core:1.25, corex:1.25, pro:1.28, prox:1.28, ultra:1.28, ultrax:1.28, max:1.28 },
};

const BUILD_TARGET_RES = {
 core: '1080p', corex: '1080p', pro: '1080p', prox: '1080p',
 ultra: '1440p', ultrax: '1440p', max: '4k',
};

// Esports titles are CPU-limited at high FPS — frame gen provides less uplift
const ESPORTS_MULT = {
 native: { core:1.0, corex:1.0, pro:1.0, prox:1.0, ultra:1.0, ultrax:1.0, max:1.0 },
 sr: { core:1.25, corex:1.25, pro:1.28, prox:1.28, ultra:1.28, ultrax:1.28, max:1.28 },
 xess: { core:1.25, corex:1.0, pro:1.0, prox:1.0, ultra:1.0, ultrax:1.0, max:1.0 },
 dlss4mfg:{ core:1.0, corex:1.0, pro:1.50, prox:1.50, ultra:1.55, ultrax:1.55, max:1.55 },
};

// ── Native FPS per build × resolution × demand anchor
// Calibrated from real GPU review data (GamersNexus, HardwareUnboxed), high settings, native raster.
//
// Core (Arc A750): ~88fps Fortnite, ~70fps CoD, ~58fps ARC Raiders, ~65fps Cyberpunk at 1080p.
// Arc A750 ≈ RTX 3060 in raster; reviewed at ~75fps Cyberpunk 1080p, XeSS adds ~35%.
// Esports: 160+ fps (CS:GO 300+ fps confirmed in reviews).
//
// Core X (Arc B580 12GB): ~210fps Fortnite (CPU-capped on 5600), ~115fps CoD,
// ~85fps ARC Raiders, ~88fps Cyberpunk 1080p Ultra. 12GB VRAM stretches to 1440p.
//
// Pro (RTX 5060 8GB): GN review — 66fps Starfield, 25% avg over 4060. Estimated ~135fps Fortnite.
// Native Cyberpunk 1080p ~90fps, CoD ~143fps. 8GB VRAM limits native 1440p heavy titles.
//
// Pro X (RTX 5060 Ti 16GB): GN review — 104fps avg 1440p, 22% over 5060. ~124fps avg 1080p.
// 1080p Cyberpunk ~104fps, CoD-class ~160fps. 16GB VRAM supports demanding 1440p.
//
// Ultra (RTX 5070 12GB): GN review — 126fps avg 1080p, 89fps Cyberpunk 1440p, ~41fps Cyberpunk 4K.
// ~90fps avg 1440p across 20 games. Cyberpunk 1080p ~130fps native.
//
// Ultra X (RTX 5070 Ti 16GB): GN review — 131fps 1080p avg, 108fps Cyberpunk 1440p, 50fps 4K.
// 24% over 5070 at 4K; 9–21% at 1080p depending on game. 7800X3D handles the 5070 Ti well at all res.
//
// Max (RTX 5090 32GB): GN review — 95fps Cyberpunk 4K (native), 214fps 1080p avg, 50% over 4090.
// 4K Cyberpunk 95fps, Fortnite 4K ~162fps native (extrapolated from resolution scaling).
const NATIVE_FPS = {
 // Calibrated from real GPU benchmarks (GamersNexus, TechSpot, Tom's Hardware, KitGuru,
 // and HowManyFPS aggregated data — verified Q1 2026).
 // Buckets are native raster FPS at high settings for each demand tier.
 // esports = ~0.95+ (Valorant/CS2 — CPU-limited at high FPS)
 // light = ~0.86 (Fortnite/Apex — competitive raster)
 // cod = ~0.70 (CoD/Helldivers — modern shooter)
 // mid = ~0.58 (Cyberpunk/AC Shadows — heavy AAA)
 // heavy = ~0.05-0.20 (Wukong Cinematic/MH Wilds — RT-or-die)
 // super = uncapped esports ceiling (e.g. CS2 on RTX 5090)
 // Build details:
 // Core    = Ryzen 5 5500   + Intel Arc A750 8GB (DDR4)
 // Core X  = Ryzen 5 5600   + Intel Arc B580 12GB (DDR4) — B580 has CPU overhead
 // Pro     = Ryzen 5 5600   + RTX 5060 8GB (DDR4)
 // Pro X   = Ryzen 5 5600X  + RTX 5060 Ti 16GB (DDR4)
 // Ultra   = Ryzen 5 7600X  + RTX 5070 12GB (DDR5)
 // Ultra X = Ryzen 7 7800X3D + RTX 5070 Ti 16GB (DDR5)
 // Max     = Ryzen 7 9800X3D + RTX 5090 32GB (DDR5)
 core: {
 // Arc A750: ~75fps Cyberpunk 1080p Ultra, ~90fps Fortnite high, modest esports ceiling.
 // Fortnite (d=0.86) lands in light bracket interpolation; calibrated so 0.86 ≈ 92fps.
 '1080p': { light:88, cod:72, mid:62, heavy:45, esports:96, super:265 },
 '1440p': { light:62, cod:51, mid:43, heavy:31, esports:68, super:188 },
 '4k': { light:42, cod:34, mid:28, heavy:21, esports:46, super:127 },
 },
 corex: {
 // Arc B580 12GB + Ryzen 5 5600. B580 ahead of A750 by ~30-40% in modern AAA but
 // takes a CPU-pairing hit; trails NVIDIA in pure esports. 12GB VRAM helps at 1440p.
 // Real measured: Cyberpunk 1080p Ultra ~85-95fps, Fortnite ~210-260fps (CPU-bound),
 // Wukong Cinematic ~28-32fps, Valorant ~340-380fps capped by CPU.
 '1080p': { light:148, cod:115, mid:88, heavy:55, esports:175, super:380 },
 '1440p': { light:113, cod:88, mid:70, heavy:42, esports:133, super:290 },
 '4k': { light:77, cod:60, mid:48, heavy:28, esports:91, super:198 },
 },
 pro: {
 // RTX 5060 + Ryzen 5 5600. ~25% gen-over-gen over 4060.
 // Cyberpunk 1080p Ultra ~85-95fps native, ~46fps 1440p, Wukong ~33fps.
 // DLSS 4 not factored into native — applied via UPSCALE_MULT.
 // Note: 8GB VRAM constrains 1440p in some titles vs Core X's 12GB B580.
 '1080p': { light:165, cod:130, mid:90, heavy:55, esports:200, super:430 },
 '1440p': { light:122, cod:96, mid:72, heavy:44, esports:148, super:315 },
 '4k': { light:80, cod:64, mid:50, heavy:30, esports:100, super:215 },
 },
 prox: {
 // RTX 5060 Ti 16GB + Ryzen 5 5600X. ~22% above RTX 5060.
 // Cyberpunk 1080p Ultra ~105-115fps native, ~70fps 1440p, Wukong ~41fps.
 // 16GB VRAM keeps high-texture games stable.
 '1080p': { light:200, cod:158, mid:110, heavy:68, esports:240, super:520 },
 '1440p': { light:148, cod:117, mid:78, heavy:48, esports:178, super:385 },
 '4k': { light:96, cod:78, mid:55, heavy:33, esports:118, super:260 },
 },
 ultra: {
 // RTX 5070 12GB + Ryzen 5 7600X (AM5/DDR5). 5070 is +32% over 5060 Ti at 1080p,
 // +48% at 1440p. 7600X holds back the esports ceiling vs an X3D part by ~15-20%.
 // GN review: ~126fps 1080p avg, ~89fps Cyberpunk 1440p, ~41fps 4K Cyberpunk.
 '1080p': { light:265, cod:210, mid:140, heavy:88, esports:320, super:680 },
 '1440p': { light:198, cod:158, mid:108, heavy:62, esports:248, super:530 },
 '4k': { light:118, cod:95, mid:65, heavy:36, esports:148, super:310 },
 },
 ultrax: {
 // RTX 5070 Ti 16GB + Ryzen 7 7800X3D (AM5/DDR5). 5070 Ti is ~24% over 5070 at 4K,
 // ~9-21% at 1080p (GPU-bound titles see more lift). 7800X3D is the proven X3D part for 1440p.
 // GN review: 131fps 1080p avg, 108fps Cyberpunk 1440p, 50fps 4K Cyberpunk.
 '1080p': { light:315, cod:250, mid:172, heavy:108, esports:380, super:830 },
 '1440p': { light:255, cod:202, mid:138, heavy:80, esports:325, super:700 },
 '4k': { light:158, cod:126, mid:84, heavy:47, esports:200, super:435 },
 },
 max: {
 // RTX 5090 32GB + Ryzen 7 9800X3D. The flagship. ~165fps Cyberpunk 1080p Ultra,
 // ~125fps 1440p, ~75fps 4K. CS2 hits 1000+ fps on this combo.
 '1080p': { light:380, cod:310, mid:200, heavy:125, esports:520, super:1224 },
 '1440p': { light:285, cod:230, mid:148, heavy:90, esports:390, super:920 },
 '4k': { light:175, cod:140, mid:88, heavy:52, esports:240, super:565 },
 },
};

const GENRE_DEMAND = {
 esports: 0.92, // Valorant/CS2/R6 — very light, esports bracket
 competitive: 0.78, // CoD-Apex range — light bracket
 openworld: 0.45, // Cyberpunk/RDR2 — mid-heavy bracket
 rpg: 0.55, // BG3/Elden Ring blend — mid bracket
 survival: 0.65, // Valheim/ARK blend — cod/mid bracket
 racing: 0.78, // Forza/F1 — light bracket
 strategy: 0.82, // Civ/Stellaris CPU-bound — light
 horror: 0.45, // RE/SH2/Dead Space — mid-heavy bracket
 mmo: 0.62, // WoW/FFXIV/PoE blend
 indie: 0.93, // Hades/Hollow Knight — esports bracket
 battleroyale:0.75, // Fortnite/Warzone blend — light bracket
 sports: 0.76, // FC 25/NBA 2K blend
 puzzle: 0.78, // Talos/Portal blend (light)
 zombie: 0.65, // L4D2/Darktide blend
 sim: 0.30, // MSFS/DCS — heavy bracket
};

const GENRE_LABELS = {
 esports: 'Esports titles are CPU-light and GPU-light — very high frame rates expected.',
 competitive: 'Competitive shooters — estimated relative to our CoD benchmarks.',
 openworld: 'Open-world AAA varies widely — typically between ARC Raiders and Cyberpunk class GPU demand.',
 rpg: 'RPG GPU demand varies — from isometric CRPGs (light) to action RPGs like BG3 or FFXVI (moderate).',
 survival: 'Survival/crafting games are typically CPU-bound — moderate GPU load.',
 racing: 'Racing games are well optimised and scale well with GPU.',
 strategy: 'Strategy games are mostly CPU-bound — GPU is under-utilised.',
 horror: 'Horror games vary widely — RE Engine remakes are moderate-light; atmospheric indie horror is very light.',
 mmo: 'MMOs are often CPU-bound for server simulation — GPU is secondary.',
 indie: 'Indie/platformer titles are typically very light on GPU.',
 battleroyale:'Battle royale titles range from light (BR with simple art) to heavy (AAA BR).',
 sports: 'Sports games are well optimised with good scalability.',
 puzzle: 'Puzzle and narrative games are very light on GPU.',
 zombie: 'Zombie/co-op survival games are moderately demanding.',
 sim: 'Simulators range from light (city builders) to extreme (MSFS 2024).',
};

// Known games dictionary — kept from v63 (unchanged, still accurate)
const KNOWN_GAMES = {
 'valorant': { demand:0.995, note:'Valorant is extremely optimised — designed to run on toasters.' },
 'cs2': { demand:0.91, note:'CS2 scales excellently; CPU matters more than GPU here.', pcOnly:true },
 'csgo': { demand:0.97, note:'CS:GO is very well optimised.', pcOnly:true },
 'counter-strike': { demand:0.91, note:'CS2 scales excellently; CPU matters more than GPU here.' },
 'counter strike': { demand:0.91, note:'CS2 scales excellently; CPU matters more than GPU here.', pcOnly:true },
 'r6': { demand:0.88, note:'R6 Siege is well optimised for high FPS.' },
 'rainbow six': { demand:0.88, note:'R6 Siege is well optimised for high FPS.' },
 'siege': { demand:0.88, note:'R6 Siege is well optimised for high FPS.' },
 'overwatch': { demand:0.89, note:'Overwatch 2 is very GPU-friendly at high FPS.' },
 'apex legends': { demand:0.88, note:'Apex sits between esports and AAA in GPU demand.' },
 'apex': { demand:0.88, note:'Apex sits between esports and AAA in GPU demand.' },
 'fortnite': { demand:0.86, note:'Using our Fortnite benchmark.' },
 'warzone': { demand:0.65, note:'Warzone is moderately GPU-heavy — newer maps are more demanding.' },
 'call of duty': { demand:0.700, note:'Using our CoD benchmark.' },
 'cod': { demand:0.700, note:'Using our CoD benchmark.' },
 'modern warfare': { demand:0.700, note:'Using our CoD benchmark.' },
 'black ops': { demand:0.700, note:'Using our CoD benchmark.' },
 'bo6': { demand:0.700, note:'Using our CoD benchmark.' },
 'halo infinite': { demand:0.88, note:'Halo Infinite is well optimised.' },
 'halo': { demand:0.88, note:'Halo Infinite is well optimised.' },
 'battlefield': { demand:0.58, note:'Battlefield titles are moderately GPU-heavy.' },
 'titanfall 2': { demand:0.93, note:'Titanfall 2 runs brilliantly on a wide range of hardware.' },
 'titanfall': { demand:0.93, note:'Titanfall 2 is wonderfully optimised.' },
 'rocket league': { demand:0.97, note:'Rocket League is exceptionally well optimised.' },
 'the finals': { demand:0.57, note:'The Finals is Unreal Engine 5 — more demanding than typical shooters.' },
 'marvel rivals': { demand:0.65, note:'Marvel Rivals runs well on RTX cards with DLSS.' },
 'deadlock': { demand:0.65, note:'Deadlock is a well-optimised Valve title.' },
 'arc raiders': { demand:0.58, note:'Using our ARC Raiders benchmark.' },
 'cyberpunk 2077': { demand:0.60, note:'Estimated at ultra/near-max settings.' },
 'cyberpunk': { demand:0.60, note:'Estimated at ultra/near-max settings.' },
 'red dead redemption 2': { demand:0.62, note:'RDR2 is one of the most GPU-demanding open-world games.' },
 'rdr2': { demand:0.62, note:'RDR2 is one of the most GPU-demanding open-world games.' },
 "assassins creed shadows":{ demand:0.25, note:"AC Shadows is Ubisoft's most demanding entry." },
 'alan wake 2': { demand:0.10, note:'Alan Wake 2 is one of the most GPU-demanding games ever released.' },
 'black myth wukong': { demand:0.05, note:'Estimated at ultra/max settings. Still very demanding.' },
 'black myth': { demand:0.05, note:'At ultra/max settings — extremely demanding even on high-end GPUs.' },
 'wukong': { demand:0.05, note:'At ultra/max settings — extremely demanding even on high-end GPUs.' },
 'ghost of tsushima': { demand:0.65, note:'GoT is a well-optimised port with great scalability.' },
 'starfield': { demand:0.52, note:'Starfield is CPU-heavy — estimates may run optimistic on high-end GPUs.' },
 'the witcher 3': { demand:0.68, note:'Witcher 3 Next-Gen with RT is GPU-intensive.' },
 'witcher': { demand:0.68, note:'Witcher 3 Next-Gen with RT is GPU-intensive.' },
 'horizon forbidden west':{ demand:0.65, note:'Horizon FW is a well-optimised Sony port.' },
 'horizon zero dawn': { demand:0.65, note:'HZD Remastered is one of the better-optimised open worlds.' },
 'horizon': { demand:0.65, note:'Horizon games are well-optimised Sony ports.' },
 'spider-man': { demand:0.72, note:"Marvel's Spider-Man games are well-optimised Sony ports." },
 'spiderman': { demand:0.72, note:"Marvel's Spider-Man games are well-optimised Sony ports." },
 'god of war': { demand:0.70, note:'GoW is a well-optimised Sony port with excellent scaling.' },
 'gow': { demand:0.70, note:'God of War is a well-optimised Sony port.' },
 'the last of us': { demand:0.35, note:'TLOU Part 1 is known for demanding GPU requirements.' },
 "baldurs gate 3": { demand:0.65, note:'BG3 is demanding, especially in Act 3 cities.' },
 'bg3': { demand:0.65, note:'BG3 varies significantly by act and area.' },
 'elden ring': { demand:0.68, note:'Elden Ring is GPU-heavy for its art style.' },
 'sekiro': { demand:0.880, note:'Sekiro is a well-optimised FromSoftware title.' },
 'monster hunter wilds': { demand:0.20, note:'MH Wilds is very GPU-heavy — RE Engine pushed hard.' },
 'monster hunter world': { demand:0.70, note:'MH World (Iceborne) is moderately demanding.' },
 'monster hunter': { demand:0.50, note:'Monster Hunter Wilds is GPU-heavy; older titles are lighter.' },
 'final fantasy xvi': { demand:0.58, note:'FF XVI is GPU-heavy.' },
 'oblivion remastered': { demand:0.18, note:'Oblivion Remastered is UE5 and significantly more demanding.' },
 'oblivion': { demand:0.18, note:'Oblivion Remastered is very GPU-demanding for a remaster.' },
 'dragon age veilguard': { demand:0.65, note:"Dragon Age: The Veilguard is well optimised for its visuals." },
 'minecraft': { demand:0.96, note:'Vanilla Minecraft is very light; shaders vary widely.' },
 'valheim': { demand:0.76, note:'Valheim is moderately demanding.' },
 'palworld': { demand:0.65, note:'Palworld has variable GPU load.' },
 'rust': { demand:0.58, note:'Rust is notoriously CPU-heavy in populated servers.' },
 'ark survival ascended': { demand:0.02, note:'ARK: Survival Ascended (UE5) is extremely demanding.' },
 'ark': { demand:0.15, note:'ARK titles are GPU-heavy — ASA (UE5) is especially so.' },
 'enshrouded': { demand:0.55, note:'Enshrouded is moderately demanding.' },
 'forza horizon 5': { demand:0.84, note:'FH5 is well optimised — scales beautifully.' },
 'forza horizon': { demand:0.84, note:'Forza Horizon games are well optimised open-world racers.' },
 'forza motorsport': { demand:0.78, note:'Forza Motorsport is well optimised and scalable.' },
 'gta v': { demand:0.85, note:'GTA V is extremely well-optimised; runs near max FPS on almost anything.' },
 'gta': { demand:0.85, note:'GTA V is extremely well-optimised; runs near max FPS on almost anything.' },
 'gta 5': { demand:0.85, note:'GTA V is extremely well-optimised; runs near max FPS on almost anything.' },
 'grand theft auto v': { demand:0.85, note:'GTA V is extremely well-optimised; runs near max FPS on almost anything.' },
 'pubg': { demand:0.85, note:'PUBG is well-optimised but CPU-heavy in late-game lobbies.', pcOnly:true },
 'pubg battlegrounds': { demand:0.85, note:'PUBG is well-optimised but CPU-heavy in late-game lobbies.' },
 'f1 25': { demand:0.84, note:'F1 25 is generally well optimised.' },
 'f1 24': { demand:0.84, note:'F1 24 is generally well optimised.' },
 'assetto corsa competizione':{ demand:0.48, note:'ACC is GPU-heavy for its visual fidelity.' },
 'assetto corsa evo': { demand:0.45, note:'AC Evo is GPU-demanding with its PBR rendering.' },
 'microsoft flight simulator':{ demand:0.06, note:'MSFS is one of the most GPU-demanding sims ever released.' },
 'msfs': { demand:0.06, note:'MSFS 2024 is extremely GPU-demanding.' },
 'dcs world': { demand:0.18, note:'DCS World is GPU-heavy in complex missions.' },
 'civilization vi': { demand:0.82, note:'Civ VI late game is CPU-bound.', pcOnly:true },
 'civilization': { demand:0.82, note:'Civilization games are CPU-bound.' },
 'stellaris': { demand:0.85, note:'Stellaris is very CPU-bound in late game.', pcOnly:true },
 'hearts of iron': { demand:0.88, note:'HoI4 is almost entirely CPU-bound.' },
 'crusader kings': { demand:0.88, note:'CK3 is CPU-bound.' },
 'total war warhammer 3': { demand:0.35, note:'TW:WH3 battles are GPU-heavy at high settings.', pcOnly:true },
 'total war': { demand:0.38, note:'Total War battles are GPU-heavy at high settings.' },
 'dota 2': { demand:0.88, note:'Dota 2 is a well-optimised MOBA.', pcOnly:true },
 'league of legends': { demand:0.97, note:'LoL is very well optimised.', pcOnly:true },
 'lol': { demand:0.97, note:'League of Legends is exceptionally well optimised.', pcOnly:true },
 'path of exile 2': { demand:0.55, note:'PoE 2 can be GPU-heavy in dense particle effects.' },
 'path of exile': { demand:0.55, note:'PoE is GPU-heavy in late-game maps.', pcOnly:true },
 'poe2': { demand:0.55, note:'Path of Exile 2 is GPU-heavy in particle-dense areas.' },
 'resident evil village': { demand:0.86, note:'RE Village is GPU-heavy with Ray Tracing.' },
 'resident evil 4': { demand:0.84, note:'RE4 Remake is GPU-heavy with RT on RE Engine.' },
 'resident evil': { demand:0.84, note:'RE Engine games are generally well optimised but visually demanding.' },
 'dead space': { demand:0.68, note:'Dead Space Remake is quite GPU-demanding.' },
 'silent hill 2': { demand:0.18, note:'SH2 Remake (UE5) is very GPU-demanding.' },
 'silent hill': { demand:0.20, note:'Silent Hill 2 Remake is GPU-heavy — UE5 Lumen/Nanite.' },
 'phasmophobia': { demand:0.58, note:'Phasmophobia is moderately demanding.', pcOnly:true },
 'lethal company': { demand:0.92, note:'Lethal Company is Unity-based; very light on GPU.' },
 'world of warcraft': { demand:0.62, note:'WoW is CPU-heavy in raids; GPU demand is moderate.' },
 'wow': { demand:0.62, note:'World of Warcraft is CPU-heavy in large group content.' },
 'final fantasy xiv': { demand:0.70, note:'FFXIV is a well-optimised MMO.' },
 'elder scrolls online': { demand:0.55, note:'ESO is well-optimised with good scalability.' },
 'diablo iv': { demand:0.57, note:'Diablo IV is moderately GPU-demanding.' },
 'diablo 4': { demand:0.57, note:'Diablo IV is moderately GPU-demanding.' },
 'genshin impact': { demand:0.88, note:'Genshin Impact is well optimised.' },
 'genshin': { demand:0.88, note:'Genshin Impact is well optimised.' },
 'wuthering waves': { demand:0.55, note:'Wuthering Waves is moderately demanding on GPU.', pcOnly:true },
 'hollow knight': { demand:0.95, note:'Hollow Knight is 2D — very light on GPU.' },
 'hogwarts legacy': { demand:0.50, note:'Hogwarts Legacy (UE4) is GPU-demanding, particularly in Hogsmeade.' },
 'hades 2': { demand:0.88, note:'Hades II is well optimised.' },
 'hades': { demand:0.90, note:'Hades is well optimised.' },
 'celeste': { demand:0.98, note:'Celeste is a pixel platformer — negligible GPU use.' },
 'deep rock galactic': { demand:0.870, note:'Deep Rock Galactic is well optimised.' },
 'remnant 2': { demand:0.30, note:'Remnant 2 (UE5) is surprisingly GPU-demanding.' },
 'slay the spire': { demand:0.98, note:'Slay the Spire is extremely light on GPU.' },
 'balatro': { demand:0.99, note:'Balatro is essentially zero GPU load.' },
 'stardew valley': { demand:0.98, note:'Stardew Valley is pixel art and barely uses GPU.' },
 'the sims 4': { demand:0.97, note:'The Sims 4 is extremely CPU-bound and very light on GPU.' },
 'sims 4': { demand:0.97, note:'The Sims 4 barely stresses the GPU — CPU-bound.' },
 'project zomboid': { demand:0.88, note:'Project Zomboid is isometric and very light on GPU.', pcOnly:true },
 'back 4 blood': { demand:0.55, note:'Back 4 Blood is moderately demanding.' },
 'left 4 dead 2': { demand:0.92, note:'Left 4 Dead 2 is old and very light on GPU.' },
 'darktide': { demand:0.55, note:'Warhammer 40K: Darktide is GPU-heavy.' },
 'dying light 2': { demand:0.49, note:'Dying Light 2 is GPU-heavy.' },
 'dying light': { demand:0.55, note:'Dying Light 2 is quite GPU-demanding.' },
 'ea sports fc': { demand:0.68, note:'EA FC is well optimised.' },
 'fifa': { demand:0.70, note:'FIFA/EA FC titles are well optimised.' },
 'nba 2k': { demand:0.62, note:'NBA 2K titles are moderately demanding.' },
 'helldivers 2': { demand:0.65, note:'Helldivers 2 is moderately demanding on GPU.' },
 'helldivers': { demand:0.65, note:'Helldivers 2 is moderately demanding.' },
 "dragons dogma 2": { demand:0.28, note:"Dragon's Dogma 2 (RE Engine) is very GPU-heavy." },
 'tekken 8': { demand:0.70, note:'Tekken 8 is moderately demanding for a fighting game.' },
 'street fighter 6': { demand:0.62, note:'SF6 is well optimised with good scalability.' },
 'lies of p': { demand:0.22, note:'Lies of P is a souls-like with GPU-heavy UE4 rendering.' },
 'lords of the fallen': { demand:0.12, note:'Lords of the Fallen (UE5) is very GPU-demanding.' },
 'plague tale requiem': { demand:0.18, note:'A Plague Tale: Requiem is extremely demanding.' },
 'plague tale': { demand:0.25, note:'A Plague Tale games are GPU-heavy for their visual quality.' },
 'star wars jedi': { demand:0.42, note:'Jedi: Survivor is GPU-heavy — UE4 with heavy settings.' },
 'jedi survivor': { demand:0.42, note:'Jedi: Survivor is known for demanding GPU use.' },
 'like a dragon': { demand:0.65, note:'Like a Dragon games are well-optimised RGE-engine titles.' },
 'yakuza': { demand:0.65, note:'Yakuza/LAD games are well optimised.' },
 'metaphor': { demand:0.88, note:'Metaphor: ReFantazio is well optimised.' },
 'doom: the dark ages': { demand:0.88, note:'Doom: The Dark Ages is idTech and well optimised at high FPS.' },
 'doom eternal': { demand:0.91, note:'DOOM Eternal is famously well optimised by id Software.' },
 'doom': { demand:0.92, note:'DOOM titles by id Software are exceptionally well optimised.' },
 'indiana jones': { demand:0.55, note:'Indiana Jones and the Great Circle is moderately demanding.' },
 'stalker 2': { demand:0.28, note:'S.T.A.L.K.E.R. 2 (UE5) is GPU-heavy.' },
 'stalker': { demand:0.40, note:'STALKER games are GPU-demanding, especially at high quality.' },
 'battlebit remastered': { demand:0.920, note:'Minimalist visuals; extremely light GPU', pcOnly:true },
 'ready or not': { demand:0.580, note:'UE4 tactical shooter' },
 'hell let loose': { demand:0.500, note:'Unreal Engine; fairly demanding', pcOnly:true },
 'squad': { demand:0.480, note:'UE4; CPU-heavy in large servers', pcOnly:true },
 'insurgency sandstorm': { demand:0.680, note:'UE4 tactical; well optimised' },
 'hunt showdown': { demand:0.580, note:'CryEngine; moderately demanding' },
 'tarkov': { demand:0.580, note:'Unity; known performance issues', pcOnly:true },
 'paladins': { demand:0.920, note:'Light hero shooter engine — very high fps' },
 'splitgate': { demand:0.880, note:'UE5 arena shooter; well optimised' },
 'god of war ragnarok': { demand:0.680, note:'Sony port; similar performance to GoW 2018' },
 'spider-man miles morales': { demand:0.850, note:'Well-optimised Insomniac port' },
 'ratchet and clank rift apart': { demand:0.780, note:'Well-optimised Sony port' },
 'death stranding': { demand:0.760, note:'Decima engine; well optimised' },
 'days gone': { demand:0.680, note:'Open world Sony port; well optimised' },
 'detroit become human': { demand:0.900, note:'Quantic Dream; excellent PC port' },
 'ghostrunner 2': { demand:0.760, note:'UE5 linear action; well optimised for its visuals' },
 'ghostrunner': { demand:0.880, note:'Linear fast-paced UE4; well optimised' },
 'control': { demand:0.420, note:'Remedy engine; RT-heavy high settings' },
 'quantum break': { demand:0.560, note:'Older Remedy engine; moderate demand' },
 'sons of the forest': { demand:0.620, note:'Unity survival; moderate demand' },
 "no mans sky": { demand:0.640, note:'Custom engine; variable demand' },
 'subnautica': { demand:0.760, note:'Unity survival; moderate GPU' },
 'grounded': { demand:0.820, note:'UE4; well-optimised Microsoft title' },
 'the forest': { demand:0.840, note:'Unity survival; older and well-optimised' },
 'green hell': { demand:0.720, note:'Unity survival; moderate demand' },
 'satisfactory': { demand:0.680, note:'UE4 factory builder; moderate GPU' },
 'avowed': { demand:0.560, note:'UE5 first-person RPG; moderate-heavy demand' },
 'kingdom come deliverance 2': { demand:0.420, note:'CryEngine; very demanding high' },
 'space marine 2': { demand:0.500, note:'UE5; moderately demanding' },
 'manor lords': { demand:0.620, note:'UE5 medieval strategy; moderate GPU', pcOnly:true },
 'ff7 rebirth': { demand:0.440, note:'UE5 JRPG; fairly demanding' },
 'indiana jones great circle': { demand:0.550, note:'id Tech; moderately demanding' },
 "baldurs gate 3": { demand:0.650, note:'Demanding in Act 3 cities' },
 'divinity original sin 2': { demand:0.820, note:'Larian isometric CRPG; well optimised', pcOnly:true },
 'pathfinder wrath': { demand:0.860, note:'Unity isometric RPG; light GPU', pcOnly:true },
 'pillars of eternity 2': { demand:0.900, note:'Isometric CRPG; very light GPU', pcOnly:true },
 'disco elysium': { demand:0.940, note:'Narrative RPG; minimal GPU requirements', pcOnly:true },
 'wasteland 3': { demand:0.900, note:'Isometric RPG; very light', pcOnly:true },
 'talos principle 2': { demand:0.580, note:'UE5 puzzle game; moderate GPU demand' },
 'outer worlds': { demand:0.720, note:'UE4; well optimised' },
 'persona 5 royal': { demand:0.920, note:'Well-optimised Atlus JRPG port — very high fps' },
 'dragon quest xi': { demand:0.860, note:'Well-optimised Square Enix JRPG' },
 'like a dragon infinite wealth': { demand:0.650, note:'RGG Studio engine; well optimised' },
 'yakuza like a dragon': { demand:0.650, note:'RGG Studio engine; well optimised' },
 'metaphor refantazio': { demand:0.880, note:'Well-optimised Atlus JRPG' },
 'ni no kuni 2': { demand:0.880, note:'Well-optimised anime JRPG' },
 'age of empires iv': { demand:0.880, note:'Relic Essence engine; well-optimised RTS', pcOnly:true },
 'age of empires 2 de': { demand:0.930, note:'Very light remaster of a classic RTS — very high fps', pcOnly:true },
 'company of heroes 3': { demand:0.680, note:'Essence engine; moderate GPU demand', pcOnly:true },
 'starcraft 2': { demand:0.930, note:'Old Blizzard engine; extremely well optimised', pcOnly:true },
 'anno 1800': { demand:0.680, note:'City builder; moderate GPU' },
 'cities skylines 2': { demand:0.460, note:'UE5 city builder; known performance issues' },
 'cities skylines': { demand:0.760, note:'Unity; moderate GPU demand' },
 'victoria 3': { demand:0.840, note:'Paradox engine; mostly CPU-bound', pcOnly:true },
 'bannerlord': { demand:0.620, note:'Custom engine; moderate GPU' },
 'rimworld': { demand:0.960, note:'Unity isometric; very light GPU', pcOnly:true },
 'total war three kingdoms': { demand:0.380, note:'CPU + GPU demanding', pcOnly:true },
 'shadow of war': { demand:0.720, note:'Monolith open world; well optimised' },
 'ea sports fc 25': { demand:0.840, note:'Frostbite; well-optimised sports sim' },
 'nba 2k25': { demand:0.680, note:'Well-optimised sports game' },
 'wreckfest': { demand:0.720, note:'Bugbear engine; well-optimised destruction racing' },
 'dirt rally 2': { demand:0.760, note:'Codemasters EGO engine; well optimised' },
 'the crew motorfest': { demand:0.700, note:'Ivory Tower; moderate GPU demand' },
 'wrc generations': { demand:0.760, note:'EGO engine; well-optimised rally game' },
 'factorio': { demand:0.920, note:'Custom engine; mostly CPU-bound, light GPU', pcOnly:true },
 'dyson sphere program': { demand:0.820, note:'Unity factory game; light GPU', pcOnly:true },
 'astroneer': { demand:0.820, note:'UE4; well-optimised exploration game' },
 'terraria': { demand:0.980, note:'XNA/FNA; minimal GPU requirements' },
 "dont starve together": { demand:0.960, note:'Very light 2D art style survival' },
 'core keeper': { demand:0.960, note:'Pixel art top-down; minimal GPU' },
 'dead by daylight': { demand:0.880, note:'UE4; well-optimised asymmetric horror' },
 'little nightmares 2': { demand:0.900, note:'UE4 horror; well-optimised — very high fps' },
 'amnesia rebirth': { demand:0.860, note:'HPL3 engine; very light GPU requirements' },
 'alien isolation': { demand:0.930, note:'Custom engine; old and extremely well-optimised' },
 'the quarry': { demand:0.640, note:'Unreal interactive horror' },
 'poppy playtime': { demand:0.800, note:'UE4 horror; moderate GPU' },
 'portal 2': { demand:0.960, note:'Source engine; extremely light' },
 'half life alyx': { demand:0.700, note:'Source 2 VR-optimised; well-optimised' },
 'the witness': { demand:0.860, note:'Well-optimised first-person puzzle' },
 'outer wilds': { demand:0.880, note:'Unity exploration; well optimised' },
 'tunic': { demand:0.920, note:'Light isometric action-puzzle game' },
 'inside': { demand:0.980, note:'Very light 2D puzzle platformer' },
 'ori and the blind forest': { demand:0.960, note:'Light 2D platformer — very high fps' },
 'ori and the will of the wisps': { demand:0.940, note:'Light 2D platformer — very high fps' },
 'cuphead': { demand:0.960, note:'Hand-drawn animation; very light GPU' },
 'it takes two': { demand:0.860, note:'UE4 co-op; well optimised' },
 'a way out': { demand:0.860, note:'Frostbite co-op; well optimised' },
 'split fiction': { demand:0.780, note:'Hazelight UE5; well-optimised co-op' },
 'what remains of edith finch': { demand:0.880, note:'UE4 walking sim; very light' },
 'nioh 2': { demand:0.880, note:'Team Ninja; well-optimised' },
 'dark souls 3': { demand:0.880, note:'FromSoftware PC port; well-optimised' },
 'dark souls remastered': { demand:0.880, note:'Old engine remaster — runs at 60fps locked on nearly anything.' },
 'blasphemous 2': { demand:0.950, note:'Pixel art souls-like; very light GPU' },
 'dead cells': { demand:0.960, note:'Metroidvania roguelite; very light GPU' },
 'rogue legacy 2': { demand:0.950, note:'Pixel art platformer roguelite; very light GPU' },
 'nier automata': { demand:0.760, note:'PlatinumGames; well-optimised' },
 'nier replicant': { demand:0.880, note:'Well-optimised remaster' },
 'vampire survivors': { demand:0.980, note:'Pixel art rogue-lite; minimal GPU' },
 'brotato': { demand:0.990, note:'Pixel roguelite; minimal GPU' },
 'binding of isaac': { demand:0.990, note:'Unity 2D roguelite; minimal GPU' },
 'among us': { demand:0.990, note:'Unity; minimal GPU requirements' },
 'enter the gungeon': { demand:0.970, note:'Unity 2D bullet-hell roguelite; very light' },
 'spelunky 2': { demand:0.970, note:'2D platformer roguelite; very light GPU' },
 'neon white': { demand:0.920, note:'Unity fast-paced; well-optimised' },
 'sifu': { demand:0.860, note:'UE4/UE5 action; well-optimised' },
 'ghostwire tokyo': { demand:0.520, note:'UE4 open world; moderately demanding' },
 'content warning': { demand:0.940, note:'Unity; very light co-op horror game' },
 'fall guys': { demand:0.840, note:'Unreal Engine; well-optimised party battle royale' },
 'golf with friends': { demand:0.940, note:'UE4; very light party golf game' },
 'pummel party': { demand:0.930, note:'UE4 party game; very light GPU' },
 'overcooked 2': { demand:0.950, note:'Unity party cooking game; very light' },
 'euro truck simulator 2': { demand:0.720, note:'SCS engine; well-optimised simulation' },
 'american truck simulator': { demand:0.720, note:'SCS engine; well-optimised trucking sim' },
 'farming simulator 25': { demand:0.760, note:'Giants Engine; moderate GPU demand' },
 'planet coaster 2': { demand:0.600, note:'Frontier engine; moderate GPU demand' },
 'planet zoo': { demand:0.620, note:'Frontier engine; moderate demand' },
 'jurassic world evolution 2': { demand:0.680, note:'Frontier engine; well-optimised management game' },
 'two point campus': { demand:0.840, note:'Two Point Engine; well-optimised management sim' },
 'parkitect': { demand:0.900, note:'Unity; light park management game' },
 'new world aeternum': { demand:0.580, note:'Amazon engine; fairly demanding', pcOnly:true },
 'black desert online': { demand:0.580, note:'Proprietary engine; demanding MMO' },
 'guild wars 2': { demand:0.760, note:'ArenaNet engine; moderate GPU demand' },
 'lost ark': { demand:0.820, note:'Isometric MMORPG; moderate GPU demand', pcOnly:true },
 'albion online': { demand:0.880, note:'Unity sandbox MMO; light GPU', pcOnly:true },
 'runescape': { demand:0.940, note:'Jagex engine; very light GPU' },
 'old school runescape': { demand:0.970, note:'Minimal GPU requirements — mostly CPU/network' },
 'warhammer vermintide 2': { demand:0.700, note:'Bitsquid engine; well-optimised co-op' },
 'age of sigmar realms of ruin': { demand:0.620, note:'UE4 RTS; moderate GPU demand' },
 'shadow of mordor': { demand:0.820, note:'Older Monolith open world; well-optimised.' },
 'ori blind forest': { demand:0.960, note:'Light 2D platformer.' },
 'ori will of wisps': { demand:0.940, note:'Light 2D platformer.' },
 'ori': { demand:0.950, note:'Ori games are light 2D platformers.' },
 'golf with your friends': { demand:0.940, note:'UE4; very light party golf game.' },
 'golf with friends': { demand:0.940, note:'UE4; very light party golf game.' },
 'ni no kuni 2': { demand:0.880, note:'Well-optimised anime JRPG.' },
 'ni no kuni': { demand:0.880, note:'Anime JRPGs are well optimised.' },
 'divinity 2': { demand:0.820, note:'Larian isometric CRPG; well optimised.' },
 'divinity': { demand:0.820, note:'Larian isometric CRPG; well optimised.' },
 'ratchet and clank': { demand:0.780, note:'Well-optimised Sony port.' },
 'ratchet & clank': { demand:0.780, note:'Well-optimised Sony port.' },
 'rift apart': { demand:0.780, note:'Well-optimised Sony port.' },
 'farming simulator': { demand:0.760, note:'Giants Engine; moderate GPU demand.' },
 'farming sim': { demand:0.760, note:'Giants Engine; moderate GPU demand.' },
 'euro truck simulator': { demand:0.720, note:'SCS engine; well-optimised simulation.' },
 'euro truck': { demand:0.720, note:'SCS engine; well-optimised simulation.' },
 'american truck': { demand:0.720, note:'SCS engine; well-optimised trucking sim.' },
 'the crew motorfest': { demand:0.700, note:'Ivory Tower; moderate GPU demand.' },
 'the crew': { demand:0.700, note:'Ivory Tower racing; moderate GPU.' },
 'company of heroes': { demand:0.680, note:'Essence engine; moderate GPU demand.' },
 'jurassic world evolution': { demand:0.680, note:'Frontier engine; well-optimised management game.' },
 'jurassic world': { demand:0.680, note:'Frontier engine; well-optimised management game.' },
 'insurgency sandstorm': { demand:0.680, note:'UE4 tactical; well optimised.' },
 'insurgency': { demand:0.680, note:'UE4 tactical shooter; well optimised.' },
 'talos principle': { demand:0.580, note:'UE5 puzzle game; moderate GPU demand.' },
 'arc raiders': { demand:0.580, note:'UE5 extraction shooter; moderate demand.' },
 'assetto corsa competizione': { demand:0.480, note:'ACC is GPU-heavy for its visual fidelity.' },
 'acc': { demand:0.480, note:'Assetto Corsa Competizione is GPU-heavy.' },
 'the finals': { demand:0.570, note:'UE5 destruction shooter; moderately demanding.' },
 'finals': { demand:0.570, note:'UE5 destruction shooter; moderately demanding.' },
};

function estimateCustomGame() {
 try {
 var input = document.getElementById('cmGameInput');
 var preset = document.getElementById('cmGamePreset');
 var upscaleSel = document.getElementById('cmUpscaleMode');
 var resSel = document.getElementById('cmResolution');
 var result = document.getElementById('cmGameResult');
 if (!result) return;

 var gameName = input ? input.value.trim() : '';
 var genreKey = preset ? preset.value : '';
 var upscaleKey = upscaleSel ? upscaleSel.value : 'sr';
 var resKey = resSel ? resSel.value : 'auto';

 if (!gameName && !genreKey) {
 result.innerHTML = '<p style="color:var(--text-tertiary);font-size:13px;padding:10px 0;">Enter a game title or select a genre above.</p>';
 return;
 }

 if (typeof SYSTEMS === 'undefined' || !selected.length) {
 grassanError('EST-001');
 return;
 }

 var selectedSystems = selected.map(function(k) { return { key:k, sys:SYSTEMS[k] }; })
 .sort(function(a,b) { return a.sys.priceNum - b.sys.priceNum; });

 var demand, note;
 // Strip apostrophes entirely first, then replace remaining punctuation with space.
 var lookupKey = gameName.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim();

 var matched = null;
 // 1. Exact match wins
 if (KNOWN_GAMES[lookupKey]) {
 matched = KNOWN_GAMES[lookupKey];
 } else if (typeof GAME_NAME_ALIASES !== 'undefined' && GAME_NAME_ALIASES[lookupKey] && KNOWN_GAMES[GAME_NAME_ALIASES[lookupKey]]) {
 // 2. Alias match (e.g. "dark souls iii" → "dark souls 3")
 matched = KNOWN_GAMES[GAME_NAME_ALIASES[lookupKey]];
 } else {
 // 3. Word-boundary substring match. Prefer the LONGEST key that matches —
 // this prevents short keys like "ark" from matching inside "dark souls".
 var bestKey = '';
 for (var k in KNOWN_GAMES) {
 // Build word-boundary regex: key must be surrounded by start/end or non-word chars
 var pattern = new RegExp('(^|\\s)' + k.replace(/[.*+?^${}()|[\]\\]/g,'\\$&') + '(\\s|$)');
 if (pattern.test(lookupKey) && k.length > bestKey.length) {
 bestKey = k;
 }
 }
 if (bestKey) matched = KNOWN_GAMES[bestKey];
 }

 if (matched) {
 demand = matched.demand;
 note = matched.note;
 var isPcOnly = !!matched.pcOnly;
 } else if (genreKey) {
 demand = GENRE_DEMAND[genreKey] || 0.50;
 note = GENRE_LABELS[genreKey] || '';
 var isPcOnly = false;
 } else {
 demand = 0.45;
 note = 'Unknown title — estimated as a moderately GPU-demanding game.';
 var isPcOnly = false;
 }

 var modeLabel = upscaleSel ? upscaleSel.options[upscaleSel.selectedIndex].text : '';
 var resLabel = resSel ? resSel.options[resSel.selectedIndex].text : '1080p';

 var demandBracket = demand >= 0.85 ? 'esports' :
 demand >= 0.75 ? 'light' :
 demand >= 0.61 ? 'cod' :
 demand >= 0.35 ? 'mid' : 'heavy';

 var rows = selectedSystems.map(function(s) {
 var compat = UPSCALE_COMPAT[s.key] || ['native','sr'];
 var isCompat = compat.indexOf(upscaleKey) !== -1;
 var effectiveKey = isCompat ? upscaleKey : (UPSCALE_FALLBACK[s.key] || 'sr');
 var compatWarn = isCompat ? null : (
 (UPSCALE_COMPAT_NOTES[s.key] && UPSCALE_COMPAT_NOTES[s.key][upscaleKey])
 || 'This upscaling method is not supported on this GPU — showing balanced SR estimate.');

 var mult = UPSCALE_MULT[effectiveKey] || UPSCALE_MULT.sr;
 var buildResKey = (resKey === 'auto') ? (BUILD_TARGET_RES[s.key] || '1080p') : resKey;
 var resBucket = NATIVE_FPS[s.key] ? NATIVE_FPS[s.key][buildResKey] : null;
 var native_fps;
 if (resBucket) {
 if (demandBracket === 'esports') {
 var te2 = (demand - 0.85) / 0.15;
 native_fps = Math.round(resBucket.esports + ((resBucket.super || resBucket.esports * 1.3) - resBucket.esports) * Math.min(te2, 1));
 } else if (demandBracket === 'light') {
 var tl2 = (demand - 0.75) / 0.10;
 native_fps = Math.round(resBucket.light + (resBucket.esports - resBucket.light) * Math.min(tl2, 1));
 } else if (demandBracket === 'cod') {
 var tc2 = (demand - 0.61) / 0.14;
 native_fps = Math.round(resBucket.cod + (resBucket.light - resBucket.cod) * Math.min(tc2, 1));
 } else if (demandBracket === 'mid') {
 var t2 = (demand - 0.35) / (0.60 - 0.35);
 native_fps = Math.round(resBucket.heavy + (resBucket.mid - resBucket.heavy) * t2);
 } else {
 var heavyFloor2 = Math.min(12, resBucket.heavy * 0.30);
 native_fps = Math.round(heavyFloor2 + (resBucket.heavy - heavyFloor2) * (demand / 0.35));
 }
 } else {
 native_fps = 60;
 }

 var _noFg = false;
 if (gameName && typeof FPS_NO_FRAMEGEN !== 'undefined') {
 var _fgKey = _normalizeGameName(gameName);
 _noFg = FPS_NO_FRAMEGEN.has(_fgKey) || FPS_NO_FRAMEGEN.has(GAME_NAME_ALIASES[_fgKey] || '');
 }
 var effectiveMult;
 if (_noFg) {
 var _srT = (demandBracket === 'esports' && UPSCALE_SR_ONLY_ESPORTS[effectiveKey])
 ? UPSCALE_SR_ONLY_ESPORTS[effectiveKey]
 : (UPSCALE_SR_ONLY[effectiveKey] || UPSCALE_SR_ONLY.sr);
 effectiveMult = _srT[s.key] || 1.0;
 } else {
 effectiveMult = (demandBracket === 'esports' && ESPORTS_MULT[effectiveKey])
 ? (ESPORTS_MULT[effectiveKey][s.key] || 1.0)
 : (mult[s.key] || 1.0);
 }
 var with_upscale = Math.round(native_fps * effectiveMult);
 // Apply FPS lock if game is in FPS_LOCKED
 var capInfo = null;
 if (gameName && typeof FPS_LOCKED !== 'undefined') {
 var _lockKey = _normalizeGameName(gameName);
 var lockEntry = FPS_LOCKED[_lockKey] || FPS_LOCKED[GAME_NAME_ALIASES[_lockKey] || ''];
 if (lockEntry && with_upscale > lockEntry.cap) {
 capInfo = lockEntry;
 with_upscale = lockEntry.cap;
 }
 }
 var lo = Math.round(with_upscale * 0.90);
 var hi = Math.round(with_upscale * 1.10);
 return { key:s.key, name:s.sys.name, lo:lo, hi:hi, compatWarn:compatWarn, effectiveKey:effectiveKey, resKey:buildResKey, cap:capInfo };
 });

 var resLabelFinal = (resKey === 'auto') ? 'auto' : resLabel;
 renderGameResult(result, gameName || (preset ? preset.options[preset.selectedIndex].text : 'Custom game'), rows, note, modeLabel, resLabelFinal, isPcOnly);
 } catch(err) {
 grassanError('EST-002', err.message);
 }
}

function renderGameResult(container, gameName, rows, note, modeLabel, resLabel, isPcOnly) {
 var colors = { core:'#0071e3', corex:'#30d158', pro:'#0071e3', prox:'#0071e3', ultra:'#ff9f0a', ultrax:'#ff9f0a', max:'#ff453a' };
 var maxFps = Math.max.apply(null, rows.filter(Boolean).map(function(r) { return r.hi; }));

 var html = '<div style="background:var(--white);border:1px solid var(--light-gray);border-radius:10px;padding:16px 18px;margin-top:12px;">';

 html += '<div style="font-size:13px;font-weight:600;color:var(--text);margin-bottom:3px;">' + (gameName || 'Your game') + '</div>';
 var metaParts = ['High settings'];
 if (resLabel && resLabel !== 'auto') metaParts.push(resLabel);
 else if (resLabel === 'auto') metaParts.push("Each build's target display");
 if (modeLabel) metaParts.push(modeLabel);
 if (metaParts.length) {
 html += '<div style="font-size:11px;color:var(--text-tertiary);margin-bottom:12px;">' + metaParts.join(' · ') + '</div>';
 }

 rows.forEach(function(row) {
 if (!row) return;
 var c = colors[row.key] || '#0071e3';
 var pct = maxFps > 0 ? Math.round((row.hi / maxFps) * 90) : 50;

 var rowResTag = (resLabel === 'auto' && row.resKey)
 ? '<span style="font-size:9px;color:var(--text-tertiary);background:var(--off-white);border:1px solid var(--light-gray);border-radius:4px;padding:1px 4px;margin-left:4px;">' + row.resKey.toUpperCase() + '</span>'
 : '';

 var fpsLabel;
 if (row.cap) {
 fpsLabel = row.cap.cap + ' fps <span style="font-size:9px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;opacity:0.65;border-bottom:1px dotted currentColor;padding-bottom:1px;margin-left:4px;">capped</span>';
 } else {
 fpsLabel = row.lo + '–' + row.hi + ' fps';
 }

 html += '<div style="margin-bottom:' + (row.compatWarn ? '4px' : '9px') + ';">';
 html += '<div style="display:flex;align-items:center;gap:10px;">' +
 '<span style="font-size:12px;color:var(--text-secondary);width:56px;flex-shrink:0;font-weight:500;">' + row.name + rowResTag + '</span>' +
 '<div style="flex:1;height:6px;background:#e8e8ed;border-radius:3px;overflow:hidden;">' +
 '<div style="width:' + pct + '%;height:100%;background:' + c + ';border-radius:3px;transition:width 0.7s cubic-bezier(0.16,1,0.3,1);"></div>' +
 '</div>' +
 '<span style="font-size:12px;color:var(--text-secondary);white-space:nowrap;text-align:right;min-width:80px;">' + fpsLabel + '</span>' +
 '</div>';

 if (row.compatWarn) {
 html += '<div style="display:flex;align-items:flex-start;gap:5px;margin-top:4px;margin-bottom:5px;padding:5px 8px;' +
 'background:#fff8ec;border:1px solid #f5c842;border-radius:6px;">' +
 '<span style="font-size:10px;flex-shrink:0;margin-top:1px;">⚠</span>' +
 '<span style="font-size:10px;color:#8a6000;line-height:1.45;">' + row.compatWarn + '</span>' +
 '</div>';
 }

 html += '</div>';
 });

 // PC-only banner (shown when the game has no console release).
 if (isPcOnly) {
 html += '<div style="display:flex;align-items:flex-start;gap:6px;margin-top:8px;padding:8px 10px;' +
 'background:#f0f8ff;border:1px solid #c5d9ef;border-radius:6px;">' +
 '<span style="font-size:11px;flex-shrink:0;margin-top:1px;">🖥️</span>' +
 '<span style="font-size:11px;color:#1a4d8f;line-height:1.5;">' +
 '<strong>PC only</strong> — this game is not available on PlayStation or Xbox.' +
 '</span>' +
 '</div>';
 }

 // FPS cap note (shown once for the whole result if any row hit the cap)
 var capRow = rows.filter(Boolean).find(function(r) { return r.cap; });
 if (capRow) {
 html += '<div style="display:flex;align-items:flex-start;gap:6px;margin-top:8px;padding:8px 10px;' +
 'background:#eef4ff;border:1px solid #b8d0ff;border-radius:6px;">' +
 '<span style="font-size:11px;flex-shrink:0;margin-top:1px;">🔒</span>' +
 '<span style="font-size:11px;color:#1a4d8f;line-height:1.5;">' +
 '<strong>FPS-locked at ' + capRow.cap.cap + '</strong> — ' + capRow.cap.note +
 '</span>' +
 '</div>';
 }

 html += '<p style="font-size:11px;color:var(--text-tertiary);margin-top:6px;line-height:1.5;border-top:1px solid var(--divider);padding-top:8px;">⚠ Estimate only. ' + note + '</p>';
 html += '</div>';
 container.innerHTML = html;

 setTimeout(function() {
 container.querySelectorAll('div[style*="transition:width"]').forEach(function(el) {
 var w = el.style.width; el.style.width = '0%';
 requestAnimationFrame(function() { el.style.width = w; });
 });
 }, 50);
}
